/* eslint-disable */
import * as React from 'react';
import React__default, { createContext, useContext, useState, useEffect } from 'react';
import { Accordion as Accordion$1, AccordionSummary, Typography, AccordionDetails, useTheme, Box, Autocomplete, Avatar, TextField, Card as Card$1, CardContent, FormGroup, FormControlLabel, Checkbox, Link, Button, Dialog, DialogContent, DialogContentText, DialogActions, ListItem, List, Pagination, ListItemText, Grid, Chip, CircularProgress, ListItemIcon, Alert, Tooltip as Tooltip$1, FormControl, FormLabel, RadioGroup, Radio, Skeleton, DialogTitle, IconButton, Switch, Stack, AppBar, Tabs, Tab, lighten, createTheme, darken, ThemeProvider as ThemeProvider$1, CssBaseline } from '@mui/material';
import { ChevronDown, Bank, ChevronRight, BankTransferOut, BankRemove, Tablet, CloudLock, Connection, BankCheck, CheckboxMultipleMarked, InformationOutline, Close, Pencil, Delete, AlertCircle } from 'mdi-material-ui';
import { SharingDuration, Status, AccessFrequency, ConsumerType, PostUsageAction, Industry, BankingTransactionTypeEnum, BankingTransactionStatusEnum, BankingTransactionExtendedDataExtensionUTypeEnum, BankingTransactionExtendedDataServiceEnum, NotificationType } from '@adatree/react-api-sdk';
import { format, parseISO, addDays, addWeeks, addMonths, addYears } from 'date-fns';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LoadingButton } from '@mui/lab';
import { SvgIcon } from '@mui/material/';
import { Global } from '@emotion/react';

const isDebug = () => {
    const isEnvDebugSet = process.env.REACT_APP_ENABLE_DEBUG === 'true';
    const isLocalDebugSet = localStorage.getItem('debug') === 'true';
    return isEnvDebugSet || isLocalDebugSet;
};
const Debugger = {
    isDebug,
};

const emitLogMessage = (messageType, message, ...supportingDetails) => {
    // eslint-disable-next-line no-console
    console[messageType](message, ...supportingDetails);
};
const debug = (primaryMessage, ...supportingData) => {
    if (Debugger.isDebug()) {
        emitLogMessage('debug', primaryMessage, ...supportingData);
    }
};
const warn = (primaryMessage, ...supportingData) => {
    emitLogMessage('warn', primaryMessage, ...supportingData);
};
const error = (primaryMessage, ...supportingData) => {
    emitLogMessage('error', primaryMessage, ...supportingData);
};
const info = (primaryMessage, ...supportingData) => {
    emitLogMessage('info', primaryMessage, ...supportingData);
};
const Logger = {
    debug,
    warn,
    error,
    info,
};

const AnalyticsComponentMeta = {
    ADT_CMP_DH_TILE: { id: 'ADT_CMP_DH_TILE', description: 'Data holder tile' },
    ADT_CMP_DH_DD: { id: 'ADT_CMP_DH_DD', description: 'Data holder dropdown' },
    ADT_CMP_INS_LT_INFO: { id: 'ADT_CMP_INS_LT_INFO', description: 'Insights list item info' },
    ADT_CMP_ACCORDION: { id: 'ADT_CMP_ACCORDION', description: 'Accordion' },
};
const AnalyticsEvents = {
    PAGE_LOAD: 'Page load',
    UI_INTERACTION: 'UI interaction',
};
const AnalyticsAction = {
    OPEN: 'Open',
    CLICK: 'Click',
    CLOSE: 'Close',
    BACK: 'Back',
    NEXT: 'Next',
    RESET: 'Reset',
    SUBMIT: 'Submit',
};
const AnalyticsContext = createContext(undefined);
const useAnalytics = () => {
    const context = useContext(AnalyticsContext);
    if (!context) {
        throw new Error('useAnalytics must be used within a AnalyticsContext');
    }
    return context;
};
/**
 * A generic analytics context provider.
 *
 * @param onTrack - Callback function to handle the components tracking calls
 *
 */
const AnalyticsProvider = ({ children, onTrack }) => {
    const track = (event, componentId, componentDescription, action, value) => {
        if (onTrack) {
            onTrack(event, componentId, componentDescription, action, value);
        }
        else {
            Logger.warn('useAnalytics onTrack function is not set. To remove this warning please provide an onTrack function to the AnalyticsProvider');
            Logger.debug(`useAnalytics track called with id '${componentId}', description '${componentDescription}' and action '${action}'`);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AnalyticsContext.Provider, { value: {
                track,
            } }, children)));
};

const Accordion = (props) => {
    const { title, content, lazyLoad = false } = props;
    const { track } = useAnalytics();
    const slotProp = { transition: { unmountOnExit: true } };
    const handleOnChange = (event, expanded) => {
        if (expanded && event) {
            track(AnalyticsEvents.UI_INTERACTION, AnalyticsComponentMeta.ADT_CMP_ACCORDION.id, AnalyticsComponentMeta.ADT_CMP_ACCORDION.description, AnalyticsAction.OPEN, title);
        }
    };
    return (React__default.createElement(Accordion$1, { elevation: 0, sx: { boxShadow: '0 1px 2px rgba(0,0,0,.1)' }, slotProps: lazyLoad === true ? Object.assign({}, slotProp) : {}, onChange: handleOnChange },
        React__default.createElement(AccordionSummary, { expandIcon: React__default.createElement(ChevronDown, null), "aria-controls": `panel-content-${title.replace(' ', '-')}`, id: `panel-id-${title.replace(' ', '-')}` },
            React__default.createElement(Typography, { variant: "body1" }, title)),
        React__default.createElement(AccordionDetails, null,
            content,
            " ")));
};

const LinkExternal = (props) => {
    const { href, text } = props;
    const theme = useTheme();
    const textColour = theme.palette.text_link !== undefined ? theme.palette.text_link.main : '#1a0dab';
    return (React__default.createElement("a", { target: "_blank", rel: "noreferrer", style: { color: textColour, textDecoration: 'underline' }, href: href }, text));
};

const CopyContext = React.createContext(undefined);
const useCopy = () => {
    const context = React.useContext(CopyContext);
    if (!context) {
        throw new Error('useCopy must be used within a CopyProvider');
    }
    return context;
};
const CopyProvider = ({ children, initialCopy }) => {
    const [copy, setCopy] = React.useState(initialCopy);
    return React.createElement(CopyContext.Provider, { value: [copy, setCopy] }, children);
};

const Accreditation = (props) => {
    const { accreditationNumber, companyName, underCdrPrincipal = false } = props;
    const [copy] = useCopy();
    const theme = useTheme();
    const cdrText = underCdrPrincipal === true
        ? `${copy.common.cdr_principal_label} ${accreditationNumber}`
        : `${copy.common.accredited_recipient_label} ${accreditationNumber}`;
    const cdrLogo = theme.palette.mode === 'light'
        ? 'https://design.adatree.com.au/assets/logos/cdr-blue-logo.svg'
        : 'https://design.adatree.com.au/assets/logos/cdr-white-logo.svg';
    const cdrUrl = `https://www.cdr.gov.au/find-a-provider?provider=${accreditationNumber}`;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Box, { sx: { display: 'flex' } },
            React__default.createElement(Box, { sx: { mr: 3, width: { xs: '125px', sm: '175px' } } },
                React__default.createElement("img", { src: cdrLogo, style: { width: '100%' }, alt: cdrText })),
            React__default.createElement(Box, null,
                React__default.createElement(Typography, { variant: "body2", sx: { display: 'block', mb: { xs: 0.1, sm: 0.5 } } }, companyName),
                React__default.createElement(Typography, { variant: "body2" },
                    React__default.createElement(LinkExternal, { href: cdrUrl, text: cdrText }))))));
};

const AutocompleteDropdown = (props) => {
    const { dataHolders, label = '', defaultValue = null, disableDataHolders = [], showError = false, showNotListed = false, onChange, } = props;
    const [inputValue, setInputValue] = useState(null);
    const [error, setError] = useState(showError);
    const [copy] = useCopy();
    const { track } = useAnalytics();
    useEffect(() => {
        const notListedId = 'not-listed';
        if (showNotListed) {
            const index = dataHolders.findIndex((dataHolder) => dataHolder.dataHolderBrandId === notListedId);
            if (index > -1) {
                dataHolders.splice(index, 1);
            }
            dataHolders.push({
                dataHolderBrandId: notListedId,
                brandName: copy.component.data_holder.not_listed,
                logoUri: 'https://design.adatree.com.au/assets/images/block-icon-grey.png',
            });
        }
    }, [copy]);
    useEffect(() => {
        if (showError) {
            setError(inputValue === null ? true : false);
        }
    }, [showError]);
    const handleChange = (event, value) => {
        if (event) {
            track(AnalyticsEvents.UI_INTERACTION, AnalyticsComponentMeta.ADT_CMP_DH_DD.id, AnalyticsComponentMeta.ADT_CMP_DH_DD.description, AnalyticsAction.CLICK, value === null || value === void 0 ? void 0 : value.brandName);
            setInputValue(value);
            onChange(value);
        }
    };
    const handleFocus = () => {
        setError(false);
    };
    const handleBlur = () => {
        setError(inputValue === null ? true : false);
    };
    const isDisabled = (option) => {
        if (disableDataHolders.some((dataHolder) => dataHolder.dataHolderBrandId === option.dataHolderBrandId)) {
            return true;
        }
        return false;
    };
    const getLabel = (option) => {
        if (isDisabled(option)) {
            return `${option.brandName}  ( Consent active  )`;
        }
        return option.brandName;
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Autocomplete, { disablePortal: true, className: error === true ? 'error' : '', sx: {
                backgroundColor: (theme) => theme.palette.background_inputs.main,
                borderRadius: '4px',
                '&.error fieldset': { borderColor: (theme) => theme.palette.error.main },
            }, options: dataHolders, getOptionLabel: (option) => option.brandName, getOptionDisabled: (option) => {
                return isDisabled(option);
            }, isOptionEqualToValue: (option, value) => option.dataHolderBrandId === value.dataHolderBrandId, defaultValue: defaultValue, renderOption: (props, option) => (React__default.createElement(Typography, Object.assign({}, props, { variant: "body1", key: option.dataHolderBrandId, sx: { display: 'flex' } }),
                React__default.createElement(Avatar, { alt: "Logo", src: option.logoUri, component: 'span', sx: { mr: 2, img: { objectFit: 'contain' } }, variant: "square" },
                    React__default.createElement(Bank, null)),
                getLabel(option))), renderInput: (params) => (React__default.createElement(TextField, Object.assign({}, params, { label: label, sx: { input: { color: (theme) => theme.palette.text_main.main } } }))), onChange: handleChange, onBlur: () => handleBlur(), onFocus: () => handleFocus() }),
        React__default.createElement(Typography, { sx: { minHeight: '2.2rem' }, variant: "body2", color: "error.main" }, error && copy.error.required)));
};

const Card = (props) => {
    const { children, error = false, sx } = props;
    return (React__default.createElement(Card$1, { sx: Object.assign({ p: 2, border: '1px Solid', borderColor: (theme) => theme.palette.background_card.main, boxShadow: '0 1px 2px rgba(0,0,0,.1)', '&.error': { borderColor: 'error.main' } }, sx), className: error === true ? 'error' : '', elevation: 0 }, children));
};

const CheckboxAccordion = (props) => {
    const { title, subtitle, checkboxValue, checked = false, items, openLabel = `See what's included`, closeLabel = 'Hide', onChange, } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [isChecked, setIsChecked] = useState(checked);
    const toggleAccordion = (event) => {
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleChange = (event) => {
        setIsChecked(event.target.checked);
        onChange(event.target.checked, event.target.value);
    };
    return (React__default.createElement(Card$1, null,
        React__default.createElement(CardContent, { sx: { pl: 1 } },
            React__default.createElement(FormGroup, null,
                React__default.createElement(FormControlLabel, { label: React__default.createElement(Typography, { variant: "h5" }, title), labelPlacement: "start", sx: {
                        justifyContent: 'space-between',
                        ml: 0,
                        pl: 1,
                        '&:hover': { backgroundColor: (theme) => theme.palette.background_hover.main },
                    }, control: React__default.createElement(Checkbox, { value: checkboxValue, checked: isChecked, onChange: handleChange, inputProps: { 'aria-label': 'controlled' }, color: "button" }) })),
            subtitle && (React__default.createElement(Typography, { sx: { pl: 1, opacity: 0.7 }, variant: "subtitle1" }, subtitle)),
            items && items.length > 0 && (React__default.createElement(Box, { sx: { pl: 1 } },
                React__default.createElement(Link, { href: "#", onClick: toggleAccordion, sx: { display: 'block', mt: 3 }, color: "inherit" }, isOpen ? closeLabel : openLabel),
                isOpen && (React__default.createElement(Box, { sx: { pt: 2 } },
                    React__default.createElement("ul", null, items.map((item, i) => (React__default.createElement("li", { key: i, style: { listStyle: 'inside', paddingLeft: '12px' } }, item)))))))))));
};

const Highlight = (props) => {
    const { children } = props;
    const theme = useTheme();
    const textColour = theme.palette.text_highlight !== undefined ? theme.palette.text_highlight.main : '#000';
    return React__default.createElement("span", { style: { color: textColour, fontWeight: 'bold' } }, children);
};

const DATE_FORMAT = 'dd/MM/yyyy';
const DATE_TIME_FORMAT = 'dd/MM/yyyy hh:mm aaa';
const DATE_TIME_TZ_FORMAT = 'dd/MM/yyyy HH:mm:ss xx';
/*
 * We use date-fns format that returns the
 * formatted date string in the given format.
 * Its important to note the result may vary by locale.
 * https://date-fns.org/docs/format
 */
const formatDate = (date) => {
    if (date instanceof Date) {
        return format(date, DATE_FORMAT);
    }
    else if (typeof date === 'string') {
        try {
            return format(parseISO(date), DATE_FORMAT);
        }
        catch (error) {
            Logger.error('Unable to format date', date);
            return '';
        }
    }
    if (date) {
        Logger.error('Unable to format date', date);
    }
    return '';
};
const formatDateTime = (date) => {
    if (date instanceof Date) {
        return format(date, DATE_TIME_FORMAT);
    }
    else if (typeof date === 'string') {
        try {
            return format(parseISO(date), DATE_TIME_FORMAT);
        }
        catch (error) {
            Logger.error('Unable to format date', date);
            return '';
        }
    }
    if (date) {
        Logger.error('Unable to format date', date);
    }
    return '';
};
const formatDateTimeTz = (date) => {
    if (date instanceof Date) {
        return format(date, DATE_TIME_TZ_FORMAT);
    }
    else if (typeof date === 'string') {
        try {
            return format(parseISO(date), DATE_TIME_TZ_FORMAT);
        }
        catch (error) {
            Logger.error('Unable to format date', date);
            return '';
        }
    }
    if (date) {
        Logger.error('Unable to format date', date);
    }
    return '';
};
const Formatter = {
    formatDate,
    formatDateTime,
    formatDateTimeTz,
};

const DateDurationList = [
    {
        type: SharingDuration.OneDay,
        unit: 'd',
        value: 1,
        text: '1 day',
    },
    {
        type: SharingDuration.OneWeek,
        unit: 'w',
        value: 1,
        text: '1 week',
    },
    {
        type: SharingDuration.TwoWeeks,
        unit: 'w',
        value: 2,
        text: '2 weeks',
    },
    {
        type: SharingDuration.OneMonth,
        unit: 'm',
        value: 1,
        text: '1 month',
    },
    {
        type: SharingDuration.ThreeMonths,
        unit: 'm',
        value: 3,
        text: '3 months',
    },
    {
        type: SharingDuration.SixMonths,
        unit: 'm',
        value: 6,
        text: '6 months',
    },
    {
        type: SharingDuration.NineMonths,
        unit: 'm',
        value: 9,
        text: '9 months',
    },
    {
        type: SharingDuration.OneYear,
        unit: 'y',
        value: 1,
        text: '1 year',
    },
    {
        type: SharingDuration.OnceOff,
        unit: 'd',
        value: 0,
        text: 'Once off',
    },
    {
        type: SharingDuration.Custom,
        unit: 'na',
        value: 0,
        text: 'Custom',
    },
];

var DataRecipientType;
(function (DataRecipientType) {
    DataRecipientType["ACCREDITED_DATA_RECIPIENT"] = "ACCREDITED_DATA_RECIPIENT";
    DataRecipientType["BUSINESS_CONSUMER_DISCLOSURE_CONSENT"] = "BUSINESS_CONSUMER_DISCLOSURE_CONSENT";
    DataRecipientType["CDR_REPRESENTATIVE"] = "CDR_REPRESENTATIVE";
    DataRecipientType["GRANTEE"] = "GRANTEE";
    DataRecipientType["NON_ACCREDITED_PERSON"] = "NON_ACCREDITED_PERSON";
    DataRecipientType["TRUSTED_ADVISER"] = "TRUSTED_ADVISER";
    DataRecipientType["TRUSTED_ADVISER_SERVICE_PROVIDER"] = "TRUSTED_ADVISER_SERVICE_PROVIDER";
})(DataRecipientType || (DataRecipientType = {}));

const sortListbyDate = (list) => {
    return list.sort((a, b) => {
        const sortDateA = getConsentSortingDate(a);
        const sortDateB = getConsentSortingDate(b);
        if (sortDateA && sortDateB) {
            return sortDateA < sortDateB ? 1 : -1;
        }
        return 0;
    });
};
const getConsentSortingDate = (consent) => {
    let sortDate = consent.created;
    if (consent.status === Status.Expired) {
        sortDate = consent.sharingEndDate;
    }
    if (consent.status === Status.Revoked) {
        sortDate = consent.revoked;
    }
    return sortDate;
};
const filterListbyStatus = (list, filterBy) => {
    return list.filter((consent) => consent.status === filterBy);
};
const filterDataHoldersByConsentsAndUseCase = (dataHolders, consents, useCase) => {
    if (!dataHolders) {
        return [];
    }
    const filteredDataHolders = dataHolders.filter((dataHolder) => {
        return doesConsentExistForDataHolderAndUseCase(dataHolder, consents, useCase);
    });
    return filteredDataHolders;
};
const doesConsentExistForDataHolderAndUseCase = (dataHolder, consents, useCase) => {
    const alreadyExists = consents.filter((consent) => {
        var _a;
        return (consent.status === Status.Active &&
            ((_a = consent.useCase) === null || _a === void 0 ? void 0 : _a.id) === useCase.id &&
            consent.dataHolderBrandId === dataHolder.dataHolderBrandId);
    });
    return alreadyExists.length > 0;
};
const accessFrequencyToString = (accessFrequency) => {
    if (accessFrequency === AccessFrequency.OnceOff) {
        return 'Once-off';
    }
    return accessFrequency.charAt(0).toUpperCase() + accessFrequency.slice(1).toLowerCase();
};
const parseSharingDuration = (sharingDuration) => {
    const duration = DateDurationList.find((duration) => {
        return duration.type === sharingDuration;
    });
    return duration;
};
const parseSharingDurations = (sharingDurations) => {
    const durations = [];
    sharingDurations.forEach((sharingDuration) => {
        const found = DateDurationList.find((duration) => {
            return duration.type === sharingDuration;
        });
        if (found !== undefined) {
            durations.push(found);
        }
    });
    return durations;
};
const sharingDurationToString = (sharingDuration) => {
    const dateDuration = DateDurationList.find((duration) => {
        return duration.type === sharingDuration;
    });
    if (dateDuration) {
        return dateDuration.text;
    }
    else {
        return undefined;
    }
};
const sharingDurationToDate = (sharingDuration) => {
    const duration = parseSharingDuration(sharingDuration);
    const curDate = new Date();
    let newDate = new Date();
    if (duration) {
        if (duration.unit === 'd') {
            newDate = addDays(curDate, duration.value);
        }
        else if (duration.unit === 'w') {
            newDate = addWeeks(curDate, duration.value);
        }
        else if (duration.unit === 'm') {
            newDate = addMonths(curDate, duration.value);
        }
        else if (duration.unit === 'y') {
            newDate = addYears(curDate, duration.value);
        }
    }
    return newDate;
};
const dateDurationToDate = (duration) => {
    const curDate = new Date();
    let newDate = new Date();
    if (duration.unit === 'd') {
        newDate = addDays(curDate, duration.value);
    }
    else if (duration.unit === 'w') {
        newDate = addWeeks(curDate, duration.value);
    }
    else if (duration.unit === 'm') {
        newDate = addMonths(curDate, duration.value);
    }
    else if (duration.unit === 'y') {
        newDate = addYears(curDate, duration.value);
    }
    return newDate;
};
/**
 * Compares the compareWithBaseScopes to baseScopes
 * @param baseScopes
 * @param compareWithBaseScopes
 * @returns [] for equal or [ScopeResponse] if compareWithBaseScopes has a difference.
 */
const getScopeDifference = (baseScopes, compareWithBaseScopes) => {
    const difference = compareWithBaseScopes.filter((compareWithBaseScope) => !baseScopes.some((baseScope) => compareWithBaseScope.id === baseScope.id));
    return difference;
};
const isConsentEditable = (consent, useCase) => {
    if (!useCase.sharingDurations || consent.status !== Status.Active) {
        return false;
    }
    // ADA-3005: API does not support updating scopes
    // if (consent.useCase && consent.useCase.scopes && useCase.scopes) {
    //   const differenceA = getScopeDifference(consent.useCase?.scopes, useCase.scopes);
    //   const differenceB = getScopeDifference(useCase.scopes, consent.useCase?.scopes);
    //   if (differenceA.length > 0 || differenceB.length > 0) {
    //     return true;
    //   }
    // }
    return true;
};
const getPrimaryDataRecipients = (dataRecipients) => {
    if (dataRecipients.length === 1) {
        return dataRecipients[0];
    }
    const foundGrantee = dataRecipients.find((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.GRANTEE;
    });
    if (foundGrantee) {
        return foundGrantee;
    }
    const foundTrustedAdviser = dataRecipients.find((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.TRUSTED_ADVISER;
    });
    if (foundTrustedAdviser) {
        return foundTrustedAdviser;
    }
    const foundTrustedAdviserServiceProvider = dataRecipients.find((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.TRUSTED_ADVISER_SERVICE_PROVIDER;
    });
    if (foundTrustedAdviserServiceProvider) {
        return foundTrustedAdviserServiceProvider;
    }
    const foundBcdcRepresentative = dataRecipients.find((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.BUSINESS_CONSUMER_DISCLOSURE_CONSENT;
    });
    if (foundBcdcRepresentative) {
        return foundBcdcRepresentative;
    }
    const foundCdrRepresentative = dataRecipients.find((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.CDR_REPRESENTATIVE;
    });
    if (foundCdrRepresentative) {
        return foundCdrRepresentative;
    }
    const foundAccreditedDataRecipient = dataRecipients.find((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.ACCREDITED_DATA_RECIPIENT;
    });
    if (foundAccreditedDataRecipient) {
        return foundAccreditedDataRecipient;
    }
    return dataRecipients[0];
};
const getAdrDataRecipients = (dataRecipients) => {
    const found = dataRecipients.find((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.ACCREDITED_DATA_RECIPIENT;
    });
    if (found) {
        return found;
    }
    else {
        return getPrimaryDataRecipients(dataRecipients);
    }
};
const getNonAdrDataRecipient = (dataRecipients) => {
    const found = dataRecipients.find((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.NON_ACCREDITED_PERSON;
    });
    return found;
};
const isBcdc = (dataRecipients) => {
    if (!dataRecipients) {
        return false;
    }
    const found = dataRecipients.some((dataRecipient) => {
        return dataRecipient.type === DataRecipientType.BUSINESS_CONSUMER_DISCLOSURE_CONSENT;
    });
    return found;
};
const isOrganisation = (useCase) => {
    if (!useCase) {
        return false;
    }
    return useCase.consumerType === ConsumerType.Organisation;
};
const sortScopesByPriority = (scopes) => {
    return scopes.sort((a, b) => {
        if (a.priority !== undefined && b.priority !== undefined) {
            if (a.priority < b.priority) {
                return -1;
            }
            else if (a.priority === b.priority) {
                return 0;
            }
            else {
                return 1;
            }
        }
        else {
            return 0;
        }
    });
};
const Helper = {
    accessFrequencyToString,
    dateDurationToDate,
    filterDataHoldersByConsentsAndUseCase,
    filterListbyStatus,
    getAdrDataRecipients,
    getPrimaryDataRecipients,
    getNonAdrDataRecipient,
    getScopeDifference,
    isBcdc,
    isConsentEditable,
    isOrganisation,
    parseSharingDuration,
    parseSharingDurations,
    sharingDurationToDate,
    sharingDurationToString,
    sortListbyDate,
    sortScopesByPriority,
};

const confirmation = (companyName, endDate, sharingDuration) => {
    const common = (React__default.createElement(React__default.Fragment, null,
        "I confirm that I am allowing ",
        React__default.createElement(Highlight, null, companyName),
        " to access my data (listed above)"));
    if (endDate && sharingDuration === SharingDuration.Custom) {
        return (React__default.createElement(React__default.Fragment, null,
            common,
            " until the ",
            React__default.createElement(Highlight, null, Formatter.formatDateTime(endDate)),
            "."));
    }
    else if (sharingDuration === SharingDuration.OnceOff) {
        return (React__default.createElement(React__default.Fragment, null,
            common,
            " ",
            React__default.createElement(Highlight, null, "once"),
            "."));
    }
    else if (sharingDuration && sharingDuration !== SharingDuration.Custom) {
        return (React__default.createElement(React__default.Fragment, null,
            common,
            " for a period of ",
            React__default.createElement(Highlight, null, Helper.sharingDurationToString(sharingDuration)),
            "."));
    }
    else {
        return React__default.createElement(React__default.Fragment, null,
            common,
            ".");
    }
};
const accessFrequency = (companyName, accessFrequency) => {
    const common = React__default.createElement(React__default.Fragment, null,
        companyName,
        " will be able to access your data");
    if (accessFrequency === AccessFrequency.OnceOff) {
        return (React__default.createElement(React__default.Fragment, null,
            "Data sharing with ",
            companyName,
            " ends after ",
            React__default.createElement(Highlight, null, "first use"),
            "."));
    }
    else if (accessFrequency === AccessFrequency.Ongoing) {
        return (React__default.createElement(React__default.Fragment, null,
            common,
            " ",
            React__default.createElement(Highlight, null, "multiple times"),
            " during this period."));
    }
    else {
        return React__default.createElement(React__default.Fragment, null,
            common,
            ".");
    }
};
const currentAccess = (companyName, endDate) => {
    const common = React__default.createElement(React__default.Fragment, null,
        "You are currently allowing ",
        companyName,
        " to access your data");
    if (endDate) {
        return (React__default.createElement(React__default.Fragment, null,
            common,
            " until the ",
            React__default.createElement(Highlight, null, Formatter.formatDateTime(endDate)),
            "."));
    }
    else {
        return React__default.createElement(React__default.Fragment, null,
            common,
            ".");
    }
};
const TextBuilder = {
    accessFrequency,
    confirmation,
    currentAccess,
};

const Confirmation = (props) => {
    const { companyName, sharingDuration, endDate, onChange } = props;
    const handleConfirmationChange = (event, checked) => {
        event.stopPropagation();
        onChange(checked);
    };
    return (React__default.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
        React__default.createElement(FormControlLabel, { control: React__default.createElement(Checkbox, { color: "button", onChange: handleConfirmationChange }), label: React__default.createElement(Typography, null, TextBuilder.confirmation(companyName, endDate, sharingDuration)) })));
};

const ConsentCancelButton = (props) => {
    const { label, dialogText, onCancel } = props;
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [copy] = useCopy();
    const handleClose = () => {
        setIsDialogOpen(false);
    };
    const handleCancel = () => {
        onCancel();
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, { sx: { mb: 2, width: { xs: '100%', sm: '17rem' } }, variant: "outlined", color: "inherit", onClick: () => {
                setIsDialogOpen(true);
            } }, label),
        React__default.createElement(Dialog, { open: isDialogOpen, onClose: handleClose, "aria-labelledby": "info-dialog-title", "aria-describedby": "info-dialog-description" },
            React__default.createElement(DialogContent, null,
                React__default.createElement(DialogContentText, { id: "info-dialog-description" }, dialogText)),
            React__default.createElement(DialogActions, null,
                React__default.createElement(Button, { variant: "outlined", color: "inherit", onClick: handleClose, autoFocus: true }, copy.common.button_label_no),
                React__default.createElement(Button, { variant: "outlined", color: "inherit", onClick: handleCancel }, copy.common.button_label_yes)))));
};

const ConsentListItem = (props) => {
    const { consent, dataHolderLogoUrl, consentUrl } = props;
    const [copy] = useCopy();
    const grantee = consent.grantee;
    let textDate = '';
    let subtitle = 'Consent';
    switch (consent.status) {
        case Status.Active:
            textDate = `${copy.common.status_active_label} ${Formatter.formatDate(consent.created)}`;
            break;
        case Status.Requested:
            textDate = `${copy.common.status_requested_label} ${Formatter.formatDate(consent.created)}`;
            break;
        case Status.Expired:
            textDate = `${copy.common.status_expired_label} ${Formatter.formatDate(consent.sharingEndDate)}`;
            break;
        case Status.Revoked:
            textDate = `${copy.common.status_revoked_label} ${Formatter.formatDate(consent.revoked)}`;
            break;
    }
    if (grantee) {
        subtitle = `Consent for ${grantee.name}`;
    }
    return (React__default.createElement(ListItem, { disablePadding: true, sx: { '&:hover': { backgroundColor: (theme) => theme.palette.background_hover.main } } },
        React__default.createElement(Button, { href: consentUrl, sx: {
                display: 'flex',
                justifyContent: 'start',
                textTransform: 'inherit',
                width: '100%',
                '&:link, &:visited': { color: 'inherit' },
            } },
            React__default.createElement(Avatar, { alt: consent.dataHolderName, src: dataHolderLogoUrl, component: 'span', sx: { mr: 2, img: { height: 'auto' } }, variant: "square" },
                React__default.createElement(Bank, null)),
            React__default.createElement(Box, null,
                React__default.createElement(Typography, { variant: "h5" }, consent.dataHolderName),
                React__default.createElement(Typography, { variant: "subtitle1" },
                    React__default.createElement("span", null,
                        subtitle,
                        " ",
                        textDate))),
            React__default.createElement(Box, { sx: { ml: 'auto', display: 'flex' } },
                React__default.createElement(ChevronRight, null)))));
};

const ConsentList = ({ consents, url = '/consent/', pagination, onPagination }) => {
    const handleChange = (event, page) => {
        event.stopPropagation();
        if (onPagination) {
            onPagination(page);
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(List, null, consents.map((consent) => (React__default.createElement(ConsentListItem, { key: consent.consentId, consent: consent, consentUrl: `${url}${consent.consentId}`, dataHolderLogoUrl: consent.dataHolderLogoUri })))),
        onPagination && pagination && (React__default.createElement(Box, { sx: { display: 'flex', justifyContent: 'end', mt: 1 } },
            React__default.createElement(Pagination, { page: pagination.page, count: pagination.totalPages, size: "small", onChange: handleChange })))));
};

const DataHandlingInfo = (props) => {
    const { dataHandlers } = props;
    const [copy] = useCopy();
    const renderListItem = (text, key) => {
        return (React__default.createElement(ListItem, { sx: {
                py: '4px',
                pl: '0.5rem',
                display: 'list-item',
                ml: '2rem',
                listStyle: 'disc',
                width: 'calc(100% - 2rem)',
            }, key: key },
            React__default.createElement(ListItemText, { primary: text })));
    };
    const renderAdrList = (dataHandler) => {
        return (React__default.createElement(List, { sx: { mb: '2rem' } },
            renderListItem(copy.component.general_information.list_marketing(dataHandler.name), 0),
            renderListItem(copy.component.general_information.list_security(dataHandler.name), 1),
            renderListItem(copy.component.general_information.list_deleted, 2),
            renderListItem(copy.component.general_information.list_third_party_more_info(dataHandler.name, dataHandler.cdrPolicyUrl), 3)));
    };
    const renderCdrrList = (dataHandler) => {
        return (React__default.createElement(List, { sx: { mb: '2rem' } },
            renderListItem(copy.component.general_information.list_cdr_acknowledgement(dataHandler.name), 0),
            renderListItem(copy.component.general_information.list_third_party_more_info(dataHandler.name, dataHandler.cdrPolicyUrl), 1)));
    };
    const renderNonAdrList = (dataHandler) => {
        return (React__default.createElement(List, { sx: { mb: '2rem' } },
            renderListItem(copy.component.data_handling_info.list_non_adr_disclaimer(dataHandler.name), 0),
            renderListItem(copy.component.data_handling_info.list_data_policy(dataHandler.name, dataHandler.cdrPolicyUrl), 1)));
    };
    const renderTaList = (dataHandler) => {
        return (React__default.createElement(List, { sx: { mb: '2rem' } }, renderListItem(copy.component.data_handling_info.list_data_policy(dataHandler.name), 0)));
    };
    const renderTaspList = (dataHandler) => {
        return (React__default.createElement(List, { sx: { mb: '2rem' } }, renderListItem(copy.component.general_information.list_tasp_context(dataHandler), 0)));
    };
    return (React__default.createElement(Accordion, { title: copy.component.data_handling_info.title, content: React__default.createElement(React__default.Fragment, null, dataHandlers.map((dataHandler, index) => {
            return (React__default.createElement("div", { key: index },
                React__default.createElement(Typography, { variant: "h4" }, dataHandler.name),
                React__default.createElement(Typography, { sx: { mt: 1 } }, dataHandler.description),
                dataHandler.type === DataRecipientType.ACCREDITED_DATA_RECIPIENT && React__default.createElement(React__default.Fragment, null, renderAdrList(dataHandler)),
                dataHandler.type === DataRecipientType.CDR_REPRESENTATIVE && React__default.createElement(React__default.Fragment, null, renderCdrrList(dataHandler)),
                dataHandler.type === DataRecipientType.TRUSTED_ADVISER && React__default.createElement(React__default.Fragment, null, renderTaList(dataHandler)),
                dataHandler.type === DataRecipientType.TRUSTED_ADVISER_SERVICE_PROVIDER && (React__default.createElement(React__default.Fragment, null, renderTaspList(dataHandler))),
                dataHandler.type === DataRecipientType.NON_ACCREDITED_PERSON && React__default.createElement(React__default.Fragment, null, renderNonAdrList(dataHandler))));
        })) }));
};

const DataHolderTiles = (props) => {
    const { dataHolders, disableDataHolders = [], onClick } = props;
    const { track } = useAnalytics();
    const theme = useTheme();
    let tileWidthXS = '50%';
    let tileWidthSM = '25%';
    let tileWidthMD = '20%';
    const tileWidthLG = '25%';
    let cardHeightXS = '45vw';
    let cardHeightSM = '16rem';
    if (dataHolders.length > 4) {
        tileWidthXS = '33%';
        tileWidthSM = '25%';
        tileWidthMD = '20%';
        cardHeightXS = '28vw';
        cardHeightSM = '12rem';
    }
    if (dataHolders.length === 6) {
        tileWidthXS = '33%';
        tileWidthSM = '33%';
        tileWidthMD = '16%';
        cardHeightXS = '28vw';
        cardHeightSM = '12rem';
    }
    if (dataHolders.length === 8) {
        tileWidthMD = '25%';
    }
    let titleBackground = '#fff';
    if (theme.palette.mode === 'dark') {
        titleBackground = '#dfdfdf';
    }
    const handleClick = (dataHolder, disabled) => {
        if (!disabled) {
            track(AnalyticsEvents.UI_INTERACTION, AnalyticsComponentMeta.ADT_CMP_DH_TILE.id, AnalyticsComponentMeta.ADT_CMP_DH_TILE.description, AnalyticsAction.CLICK, dataHolder.brandName);
            onClick(dataHolder);
        }
    };
    const isDisabled = (option) => {
        if (disableDataHolders.some((dataHolder) => dataHolder.dataHolderBrandId === option.dataHolderBrandId)) {
            return true;
        }
        return false;
    };
    return (React__default.createElement(Grid, { className: "adt-container", container: true, spacing: 2 }, dataHolders.map((dataHolder) => {
        const disabled = isDisabled(dataHolder);
        return (React__default.createElement(Grid, { className: "adt-card", item: true, sx: {
                cursor: 'pointer',
                position: 'relative',
                flexBasis: { xs: tileWidthXS, sm: tileWidthSM, md: tileWidthMD, lg: tileWidthLG },
            }, onClick: () => handleClick(dataHolder, disabled), key: dataHolder.dataHolderBrandId },
            React__default.createElement(Card, { sx: {
                    p: { xs: '4px', sm: '0.8rem', md: '1.6rem' },
                    height: '100%',
                    minHeight: { xs: cardHeightXS, sm: cardHeightSM },
                    alignItems: 'center',
                    display: 'flex',
                    backgroundColor: titleBackground,
                    '&:hover': {
                        backgroundColor: disabled === true ? titleBackground : (theme) => theme.palette.background_hover.main,
                        borderColor: disabled === true ? titleBackground : (theme) => theme.palette.background_hover.main,
                    },
                    '&:hover img': {
                        opacity: disabled === true ? '1' : '0.3 !important',
                    },
                } },
                React__default.createElement("img", { src: dataHolder.logoUri, alt: dataHolder.brandName, title: dataHolder.brandName, style: {
                        width: '100%',
                        opacity: disabled === true ? '0.3' : '1',
                    } })),
            disabled && (React__default.createElement(Chip, { sx: {
                    m: { xs: 1, sm: 2, md: 3 },
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    backgroundColor: 'success.main',
                    color: 'common.white',
                    fontWeight: 600,
                    fontSize: '1.4rem',
                    textTransform: 'lowercase',
                    '& span:first-letter': {
                        textTransform: 'capitalize',
                    },
                }, label: 'Active', size: "small" }))));
    })));
};

const DateButton = (props) => {
    const { sharingDurations: sharingDuration, selectedSharingDuration, disabled = false, onClick } = props;
    const dateDurations = Helper.parseSharingDurations(sharingDuration);
    const handleClick = (duration) => {
        onClick(Helper.dateDurationToDate(duration), duration.type);
    };
    return (React__default.createElement(Box, { sx: { flexWrap: 'wrap', display: 'inline-flex', width: { xs: '100%', sm: 'inherit' } } }, dateDurations.map((duration) => {
        if (duration.unit === 'na')
            return;
        return (React__default.createElement(Button, { onClick: () => handleClick(duration), variant: duration.type === selectedSharingDuration ? 'contained' : 'outlined', disabled: disabled, key: `${duration.unit}-${duration.value}`, color: duration.type === selectedSharingDuration ? 'button' : 'inherit', sx: { mr: '4px', mb: 1, width: { xs: 'calc(50% - 4px)', sm: 'inherit' } } }, duration.text));
    })));
};

const DatePicker = (props) => {
    const { label, date = null, inputFormat = 'dd/MM/yyyy', disabled = false, onChange } = props;
    const [value, setValue] = useState(date);
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 1);
    useEffect(() => {
        setValue(date);
    }, [props.date, setValue]);
    const handleChange = (newValue) => {
        if (newValue) {
            setValue(newValue);
            onChange(newValue);
        }
    };
    return (React__default.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns },
        React__default.createElement(MobileDatePicker, { label: label, minDate: new Date(), maxDate: maxDate, format: inputFormat, value: value, disabled: disabled, onChange: handleChange, slotProps: { textField: { sx: { input: { color: (theme) => theme.palette.text_main.main } } } } })));
};

const FeedbackMessage = (props) => {
    const { message, icon, children, showSpinner = false } = props;
    return (React__default.createElement(Box, { sx: { p: 2, display: 'flex', alignItems: 'center', flexDirection: 'column' } },
        showSpinner && React__default.createElement(CircularProgress, { sx: { m: 1, color: 'primary.main' }, "aria-label": "Loading" }),
        !showSpinner && icon,
        React__default.createElement(Typography, { variant: "body1", sx: { m: 3 } }, message),
        children));
};

const DataRecipientsContext = React.createContext(undefined);
const useDataRecipients = () => {
    const context = React.useContext(DataRecipientsContext);
    if (!context) {
        throw new Error('useDataRecipients must be used within a DataRecipientsProvider');
    }
    return context;
};
const DataRecipientsProvider = ({ accreditationNum, children, initialDataRecipients }) => {
    const [accreditationNumber] = React.useState(accreditationNum);
    const [adrDataRecipient, setAdrDataRecipient] = React.useState(Helper.getAdrDataRecipients(initialDataRecipients));
    const [dataRecipients, setDataRecipients] = React.useState(initialDataRecipients);
    const [primaryDataRecipient, setPrimaryDataRecipient] = React.useState(Helper.getPrimaryDataRecipients(initialDataRecipients));
    const [nonAdrDataRecipient, setNonAdrDataRecipient] = React.useState(Helper.getNonAdrDataRecipient(initialDataRecipients));
    const addDataRecipient = (dataRecipient) => {
        const dataRecipientsClone = [...dataRecipients];
        dataRecipientsClone.push(dataRecipient);
        setDataRecipients(dataRecipientsClone);
        setAdrDataRecipient(Helper.getAdrDataRecipients(dataRecipientsClone));
        setPrimaryDataRecipient(Helper.getPrimaryDataRecipients(dataRecipientsClone));
        setNonAdrDataRecipient(Helper.getNonAdrDataRecipient(dataRecipientsClone));
    };
    return (React.createElement(DataRecipientsContext.Provider, { value: {
            accreditationNumber,
            adrDataRecipient,
            primaryDataRecipient,
            dataRecipients,
            nonAdrDataRecipient,
            addDataRecipient,
            setDataRecipients,
        } }, children));
};

const GeneralInformation = (props) => {
    const { hideDuplicateListItem = false } = props;
    const [copy] = useCopy();
    const { adrDataRecipient, primaryDataRecipient, nonAdrDataRecipient } = useDataRecipients();
    const renderListItem = (text) => {
        return (React__default.createElement(ListItem, { sx: {
                py: '4px',
                pl: '0.5rem',
                display: 'list-item',
                ml: '2rem',
                listStyle: 'disc',
                width: 'calc(100% - 2rem)',
            } },
            React__default.createElement(ListItemText, { primary: text })));
    };
    const getList = () => {
        return (React__default.createElement(List, { sx: { wordBreak: 'break-all' } },
            primaryDataRecipient.type !== DataRecipientType.ACCREDITED_DATA_RECIPIENT &&
                renderListItem(copy.component.general_information.list_adr_context),
            primaryDataRecipient.type === DataRecipientType.TRUSTED_ADVISER &&
                renderListItem(copy.component.general_information.list_cdr_protection),
            primaryDataRecipient.type === DataRecipientType.TRUSTED_ADVISER_SERVICE_PROVIDER &&
                renderListItem(copy.component.general_information.list_cdr_protection),
            primaryDataRecipient.type !== DataRecipientType.ACCREDITED_DATA_RECIPIENT &&
                renderListItem(copy.component.data_handling_info.list_data_policy(primaryDataRecipient.name)),
            !hideDuplicateListItem &&
                renderListItem(copy.component.general_information.list_security(adrDataRecipient.name)),
            !hideDuplicateListItem &&
                renderListItem(copy.component.general_information.list_marketing(adrDataRecipient.name)),
            !nonAdrDataRecipient && renderListItem(copy.component.general_information.list_records),
            nonAdrDataRecipient && renderListItem(copy.component.general_information.list_records_with_insights),
            renderListItem(copy.component.general_information.list_sharing),
            !hideDuplicateListItem &&
                !nonAdrDataRecipient &&
                renderListItem(copy.component.general_information.list_deleted),
            !hideDuplicateListItem &&
                nonAdrDataRecipient &&
                renderListItem(copy.component.general_information.list_deleted_with_insights),
            renderListItem(copy.component.general_information.list_revoked),
            !hideDuplicateListItem && renderListItem(copy.component.general_information.list_primary_more_info),
            renderListItem(copy.component.general_information.list_complaint),
            renderListItem(copy.component.general_information.list_manage_consent)));
    };
    return React__default.createElement(Accordion, { title: copy.component.general_information.title, content: getList() });
};

const IconListItem = (props) => {
    const { icon, content, alignIcon = 'center' } = props;
    return (React__default.createElement(ListItem, { alignItems: alignIcon },
        React__default.createElement(ListItemIcon, null, icon),
        React__default.createElement(ListItemText, { primary: content })));
};

const IconWithText = (props) => {
    const { icon, title, text } = props;
    const iconFontSize = '80px';
    let altText = 'Avatar icon';
    const getIcon = (icon) => {
        switch (icon) {
            case 'CheckboxMultipleMarked':
                altText = 'Multiple checkboxes marked icon';
                return React__default.createElement(CheckboxMultipleMarked, { color: "primary", style: { fontSize: iconFontSize } });
            case 'BankCheck':
                altText = 'Bank checked icon';
                return React__default.createElement(BankCheck, { color: "primary", style: { fontSize: iconFontSize } });
            case 'Connection':
                altText = 'Plug connection icon';
                return React__default.createElement(Connection, { color: "primary", style: { fontSize: iconFontSize } });
            case 'CloudLock':
                altText = 'Secure cloud icon';
                return React__default.createElement(CloudLock, { color: "primary", style: { fontSize: iconFontSize } });
            case 'Tablet':
                altText = 'Tablet icon';
                return React__default.createElement(Tablet, { color: "primary", style: { fontSize: iconFontSize } });
            case 'BankRemove':
                altText = 'BankRemove';
                return React__default.createElement(BankRemove, { color: "primary", style: { fontSize: iconFontSize } });
            case 'BankTransferOut':
                altText = 'BankTransferOut';
                return React__default.createElement(BankTransferOut, { color: "primary", style: { fontSize: iconFontSize } });
        }
    };
    return (React__default.createElement(Box, { sx: { alignItems: 'center', display: 'flex', flexDirection: 'column', textAlign: 'center' } },
        React__default.createElement(Avatar, { alt: altText, sx: { height: 120, width: 120, backgroundColor: 'transparent' }, variant: "square" }, getIcon(icon)),
        title && React__default.createElement(Typography, { variant: "h2" }, title),
        text && React__default.createElement(Typography, null, text)));
};

const InsightList = (props) => {
    const { insightScopes, dataHolderName } = props;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Typography, { sx: { mb: 1 } }, "Insight details"),
        insightScopes.length > 0 &&
            insightScopes.map((insight, index) => {
                return (React__default.createElement(Box, { key: `insight-details-${index}` },
                    React__default.createElement(Typography, { sx: { my: 1 } },
                        React__default.createElement(Highlight, null, insight.name)),
                    React__default.createElement(Box, { sx: { pl: 2 } },
                        insight.description && React__default.createElement(Typography, { sx: { mb: 1 } }, insight.description),
                        React__default.createElement(Typography, { sx: { mb: 0.6 } },
                            "To generate this insight we use the following data from ",
                            React__default.createElement(Highlight, null, dataHolderName)),
                        React__default.createElement(Box, { sx: { pt: 1 } },
                            React__default.createElement("ul", null, insight.claims &&
                                insight.claims.map((claim, i) => (React__default.createElement("li", { key: i, style: { listStyle: 'inside', paddingLeft: '12px' } }, claim))))))));
            }),
        insightScopes.length === 0 && React__default.createElement(Alert, { severity: "error" }, "Insights scopes not found")));
};

const MaxAccountConnectedMessage = (props) => {
    const { useCase, hideBackButton = false, onClick } = props;
    const [copy] = useCopy();
    return (React__default.createElement(Box, { sx: { m: 2 } },
        React__default.createElement(Typography, { sx: { mb: 2 }, variant: 'h2' }, copy.component.max_account_connected_message.title),
        React__default.createElement(Typography, { sx: { mb: 2 } }, copy.component.max_account_connected_message.sub_title),
        React__default.createElement(Typography, null, copy.component.max_account_connected_message.list_label),
        useCase.dataHolders && (React__default.createElement("ul", { style: { padding: '1rem' } }, useCase.dataHolders.map((dataHolder) => (React__default.createElement("li", { style: { listStyle: 'disc', marginLeft: '10px' }, key: dataHolder.dataHolderBrandId }, useCase.name && (React__default.createElement(Typography, { variant: "body2", sx: { m: 0.1 } }, copy.component.max_account_connected_message.list_item(useCase.name, dataHolder.brandName)))))))),
        !hideBackButton && (React__default.createElement(Button, { sx: { my: 2, width: { xs: '100%', sm: '20rem' } }, variant: "contained", color: "button", onClick: onClick }, copy.common.button_label_back))));
};

const NewFeature = (props) => {
    const { title = 'New', open, children, placement, description, onClose } = props;
    const content = (React__default.createElement(Box, { sx: { display: 'flex', flexDirection: 'column' } },
        React__default.createElement(Typography, { variant: "body2", sx: { mb: 1.6, color: 'common.white', fontWeight: 'bold', lineHeight: 1 } }, title),
        description && (React__default.createElement(Typography, { variant: "body2", sx: { color: 'common.white' } }, description)),
        React__default.createElement(Button, { size: "small", variant: "contained", color: "info", sx: { mt: 1, color: 'common.white', alignSelf: 'flex-end' }, onClick: () => handleClose() }, "OK")));
    const handleClose = () => {
        onClose();
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Tooltip$1, { title: content, placement: placement, open: open, onClose: handleClose, arrow: true, disableHoverListener: true, componentsProps: {
                tooltip: {
                    sx: {
                        p: 2,
                        backgroundColor: 'info.light',
                        border: '1px solid',
                        borderColor: 'info.light',
                        '.MuiTooltip-arrow:before': {
                            backgroundColor: 'info.light',
                        },
                    },
                },
            } }, children)));
};

const PartnerMessage = (props) => {
    const { dataHolderName, discreetMode = false } = props;
    const { primaryDataRecipient, dataRecipients } = useDataRecipients();
    const [copy] = useCopy();
    return (React__default.createElement("section", null,
        React__default.createElement("div", { style: { textAlign: 'center' } },
            React__default.createElement(Box, { sx: { mt: 3, mb: 1 } },
                React__default.createElement("img", { src: primaryDataRecipient.logo, alt: primaryDataRecipient.name, style: { maxWidth: '260px', width: '100%', margin: '0 auto' } })),
            !discreetMode && React__default.createElement(Typography, { sx: { mb: 1 } }, copy.component.partner_message.discreet_label),
            React__default.createElement(Typography, { variant: "h1", sx: { mb: 2.5, fontSize: discreetMode === true ? '1.8rem' : '3rem' } }, copy.common.adatree_name)),
        React__default.createElement(Box, null,
            React__default.createElement(Typography, { sx: { mb: 1 } }, copy.component.partner_message.what_label(dataRecipients)),
            React__default.createElement(Typography, { sx: { mt: 1.5, mb: 0 } }, copy.component.partner_message.why_label(dataHolderName)))));
};

const RadioButtonWithText = (props) => {
    const { label, radioButtonItems, defaultValue = '', onChange } = props;
    const handleChange = (event) => {
        onChange(event.target.value);
    };
    return (React__default.createElement(FormControl, { sx: { width: '100%' } },
        label && (React__default.createElement(FormLabel, { id: "radio-buttons-group-label" },
            React__default.createElement(Typography, { variant: "h2" }, label))),
        React__default.createElement(RadioGroup, { "aria-labelledby": "radio-buttons-group-label", defaultValue: defaultValue, name: "radio-buttons-group", onChange: handleChange }, radioButtonItems.map((item) => {
            const disabled = item.disable ? true : false;
            return (React__default.createElement("span", { key: item.value },
                React__default.createElement(FormControlLabel, { sx: {
                        m: 0,
                        pl: 1,
                        justifyContent: 'space-between',
                        '&:hover': { backgroundColor: (theme) => theme.palette.background_hover.main },
                        width: '100%',
                    }, value: item.value, control: React__default.createElement(Radio, { disabled: disabled, color: "button" }), label: React__default.createElement(Typography, { variant: "body2" }, item.label), labelPlacement: "start" }),
                item.description && (React__default.createElement(Typography, { variant: "subtitle1", sx: { pl: 1, mb: 1.5 } }, item.description))));
        }))));
};

const Tooltip = (props) => {
    const { content, title } = props;
    const body = typeof content === 'string' ? (React__default.createElement(Typography, { sx: {
            color: 'common.white',
        } }, content)) : (content);
    const text = title ? (React__default.createElement("span", { style: { cursor: 'pointer' } }, title)) : (React__default.createElement(InformationOutline, { sx: { ml: 1, pb: '2px', cursor: 'pointer', color: '#08A4E4' } }));
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Tooltip$1, { title: body, componentsProps: {
                tooltip: {
                    sx: {
                        backgroundColor: 'grey.light',
                        border: '1px solid',
                        borderColor: 'grey.dark',
                        color: 'common.white',
                    },
                },
            } }, text)));
};

const SectionCard = (props) => {
    const { title, subtitle, content, tooltip } = props;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Typography, { variant: "h2", sx: { mb: 3 } }, title ? title : React__default.createElement(Skeleton, null)),
        subtitle ? (React__default.createElement(Box, { sx: { mb: 4, display: 'flex' } },
            React__default.createElement(Typography, null, subtitle),
            tooltip && React__default.createElement(Tooltip, { content: tooltip }))) : (React__default.createElement(Skeleton, { sx: { mb: 4 }, variant: "text" })),
        content ? (React__default.createElement(Card$1, null,
            React__default.createElement(CardContent, null, content))) : (React__default.createElement(Skeleton, { variant: "rectangular", height: 200 }))));
};

const ScopeList = (props) => {
    var _a;
    const { scopes } = props;
    const [scope, setScope] = useState();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [copy] = useCopy();
    const theme = useTheme();
    const sortedScopes = Helper.sortScopesByPriority(scopes);
    const handleInfoClick = (scope) => {
        setScope(scope);
        setIsDialogOpen(true);
    };
    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(List, { sx: { width: '100%', bgcolor: 'background.paper', p: 0 } },
            sortedScopes.map((scope) => {
                return (React__default.createElement(ListItem, { key: scope.id, sx: { px: 1, py: 0.5, '&:hover': { backgroundColor: (theme) => theme.palette.background_hover.main } } },
                    React__default.createElement(ListItemText, { id: `switch-list-label-${scope.id}`, primary: React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: { xs: 'space-between', sm: 'normal' },
                                } },
                                React__default.createElement(Typography, { variant: "body2" }, scope.name),
                                React__default.createElement(Box, { onClick: () => handleInfoClick(scope), sx: { display: 'flex', alignItems: 'center' } },
                                    React__default.createElement(InformationOutline, { sx: { mx: 1, cursor: 'pointer', color: '#66b0cc', fontSize: '18px' } })))) })));
            }),
            React__default.createElement(Typography, { variant: "subtitle1", sx: { px: 1, py: 1 } }, "We will only access what we need for this service")),
        React__default.createElement(Dialog, { onClose: handleDialogClose, open: isDialogOpen },
            React__default.createElement(DialogTitle, null,
                React__default.createElement("span", { style: { marginRight: '2rem' } }, scope === null || scope === void 0 ? void 0 : scope.name),
                React__default.createElement(IconButton, { "aria-label": "close", onClick: handleDialogClose, sx: {
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    } },
                    React__default.createElement(Close, null))),
            React__default.createElement(DialogContent, null,
                React__default.createElement(Typography, { sx: { mb: 1.5 } }, scope === null || scope === void 0 ? void 0 : scope.purpose),
                React__default.createElement(Typography, { sx: { mb: 0.75 } }, copy.consent.scope.tooltip_label),
                React__default.createElement("ul", null, (_a = scope === null || scope === void 0 ? void 0 : scope.claims) === null || _a === void 0 ? void 0 : _a.map((claim) => (React__default.createElement("li", { key: claim, style: {
                        paddingLeft: '0.5rem',
                        display: 'list-item',
                        marginLeft: '2rem',
                        marginBottom: '0.5rem',
                        listStyle: 'disc',
                        color: theme.palette.text_main.main,
                    } },
                    React__default.createElement(Typography, null, claim)))))))));
};

const ScopeListCheckbox = (props) => {
    const { scopes, onChange } = props;
    const [clickedValues, setclickedValues] = useState([]);
    const [copy] = useCopy();
    const sortedScopes = Helper.sortScopesByPriority(scopes);
    const handleChexboxClick = (isChecked, value) => {
        let tmpArray = clickedValues;
        if (isChecked) {
            tmpArray.push(value);
            setclickedValues([...tmpArray]);
        }
        else {
            tmpArray = tmpArray.filter((item) => item !== value);
            setclickedValues([...tmpArray]);
        }
        onChange(tmpArray.length === sortedScopes.length);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(List, { sx: { width: '100%', bgcolor: 'background.paper' } }, sortedScopes.map((scope) => {
            return (React__default.createElement("li", { key: scope.id },
                React__default.createElement(CheckboxAccordion, { title: scope.name === undefined ? '' : scope.name, checkboxValue: scope.id === undefined ? '' : scope.id, onChange: handleChexboxClick, items: scope.claims, subtitle: `
              ${scope.purpose}


              ${copy.consent.scope.tooltip_label}
              ` })));
        }))));
};

const ScopeListSwitch = (props) => {
    var _a;
    const { scopes, enableAll = false, onChange } = props;
    const [clickedValues, setclickedValues] = useState([]);
    const [scope, setScope] = useState();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [copy] = useCopy();
    const theme = useTheme();
    const sortedScopes = Helper.sortScopesByPriority(scopes);
    const handleToggle = (event, checked) => {
        const value = event.target.value;
        let tmpArray = clickedValues;
        if (checked) {
            tmpArray.push(value);
            setclickedValues([...tmpArray]);
        }
        else {
            tmpArray = tmpArray.filter((item) => item !== value);
            setclickedValues([...tmpArray]);
        }
        onChange(tmpArray.length === sortedScopes.length);
    };
    const handleInfoClick = (scope) => {
        setScope(scope);
        setIsDialogOpen(true);
    };
    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(List, { sx: { width: '100%', bgcolor: 'background.paper', p: 0 } }, sortedScopes.map((scope) => {
            return (React__default.createElement(ListItem, { key: scope.id, sx: { px: 1, py: 0.5, '&:hover': { backgroundColor: (theme) => theme.palette.background_hover.main } } },
                React__default.createElement(ListItemText, { id: `switch-list-label-${scope.id}`, primary: React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: { xs: 'space-between', sm: 'normal' },
                            } },
                            React__default.createElement(Typography, { variant: "body2" }, scope.name),
                            React__default.createElement(Box, { onClick: () => handleInfoClick(scope), sx: { display: 'flex', alignItems: 'center' } },
                                React__default.createElement(InformationOutline, { sx: { mx: 1, cursor: 'pointer', color: '#66b0cc', fontSize: '18px' } })))) }),
                React__default.createElement(Switch, { edge: "end", value: scope.id, onChange: handleToggle, defaultChecked: enableAll, color: "button", inputProps: {
                        'aria-labelledby': `switch-list-label-${scope.id}`,
                    } })));
        })),
        React__default.createElement(Dialog, { onClose: handleDialogClose, open: isDialogOpen },
            React__default.createElement(DialogTitle, null,
                React__default.createElement("span", { style: { marginRight: '2rem' } }, scope === null || scope === void 0 ? void 0 : scope.name),
                React__default.createElement(IconButton, { "aria-label": "close", onClick: handleDialogClose, sx: {
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    } },
                    React__default.createElement(Close, null))),
            React__default.createElement(DialogContent, null,
                React__default.createElement(Typography, { sx: { mb: 1.5 } }, scope === null || scope === void 0 ? void 0 : scope.purpose),
                React__default.createElement(Typography, { sx: { mb: 0.75 } }, copy.consent.scope.tooltip_label),
                React__default.createElement("ul", null, (_a = scope === null || scope === void 0 ? void 0 : scope.claims) === null || _a === void 0 ? void 0 : _a.map((claim) => (React__default.createElement("li", { key: claim, style: {
                        paddingLeft: '0.5rem',
                        display: 'list-item',
                        marginLeft: '2rem',
                        marginBottom: '0.5rem',
                        listStyle: 'disc',
                        color: theme.palette.text_main.main,
                    } },
                    React__default.createElement(Typography, null, claim)))))))));
};

const SwitchDialog = (props) => {
    const { switchTitle, dialogTitle, children, checked = false, onCheck } = props;
    const [isChecked, setIsChecked] = useState(checked);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const handleToggle = (event) => {
        setIsChecked(event.target.checked);
        onCheck(event.target.checked);
    };
    const handleInfoClick = () => {
        setIsDialogOpen(true);
    };
    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ListItem, { sx: { px: 1, py: 0.5, '&:hover': { backgroundColor: (theme) => theme.palette.background_hover.main } } },
            React__default.createElement(ListItemText, { primary: React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: { xs: 'space-between', sm: 'normal' },
                        } },
                        React__default.createElement(Typography, { variant: "body2" }, switchTitle),
                        React__default.createElement(Box, { onClick: () => handleInfoClick(), sx: { display: 'flex', alignItems: 'center' } },
                            React__default.createElement(InformationOutline, { sx: { mx: 1, cursor: 'pointer', color: '#66b0cc', fontSize: '18px' } })))) }),
            React__default.createElement(Switch, { edge: "end", value: isChecked, onChange: handleToggle, color: "button" })),
        React__default.createElement(Dialog, { onClose: handleDialogClose, open: isDialogOpen },
            React__default.createElement(DialogTitle, null,
                React__default.createElement("span", { style: { marginRight: '2rem' } }, dialogTitle),
                React__default.createElement(IconButton, { "aria-label": "close", onClick: handleDialogClose, sx: {
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    } },
                    React__default.createElement(Close, null))),
            React__default.createElement(DialogContent, null, children))));
};

const AlertInputFrom = (props) => {
    const { alertSeverity, alertMessage, inputErrorMessage, inputLabel, inputType = 'text', isLoading, primaryLabel, primaryOnClick, secondaryLabel, secondaryMessage, secondaryOnClick, fullWidth = true, } = props;
    const [inputValue, setInputValue] = useState('');
    const [isInputError, setIsInputError] = useState(!!inputErrorMessage);
    const [errorMessage, setErrorMessage] = useState(inputErrorMessage);
    return (React.createElement(Box, { sx: { maxWidth: '50rem', m: '0 auto' } },
        React.createElement(Stack, { alignItems: "center" },
            React.createElement(Alert, { sx: { m: 2, width: '100%' }, severity: alertSeverity }, alertMessage),
            React.createElement(TextField, { sx: { m: 2, width: fullWidth ? '100%' : 'auto' }, label: inputLabel, type: inputType, variant: "outlined", value: inputValue, helperText: errorMessage, error: isInputError, onChange: (e) => setInputValue(e.target.value), onFocus: () => {
                    setIsInputError(false);
                    setErrorMessage('');
                } }),
            React.createElement(LoadingButton, { sx: { m: 2, maxWidth: '20rem' }, loading: isLoading, variant: "contained", onClick: () => primaryOnClick(inputValue) }, primaryLabel),
            secondaryOnClick && secondaryLabel && (React.createElement(React.Fragment, null,
                React.createElement(Button, { sx: { m: 2, mt: 6 }, variant: "outlined", color: "inherit", onClick: secondaryOnClick }, secondaryLabel),
                React.createElement(Typography, { variant: "body2" }, secondaryMessage))))));
};

const BlockedDataholderDialog = (props) => {
    const { dataHolder, isOpen, onClose } = props;
    const [copy] = useCopy();
    const handleClose = () => {
        onClose();
    };
    return (React__default.createElement(Dialog, { open: isOpen, "aria-labelledby": "blocked-dialog-title", "aria-describedby": "blocked-dialog-description" },
        React__default.createElement(DialogContent, null,
            React__default.createElement(IconButton, { "aria-label": "close", onClick: handleClose, sx: {
                    position: 'absolute',
                    right: { xs: 4, sm: 8 },
                    top: { xs: 4, sm: 8 },
                    color: (theme) => theme.palette.button.light,
                } },
                React__default.createElement(Close, null)),
            React__default.createElement(Box, { sx: { mt: 4 } },
                React__default.createElement(Typography, { sx: { mb: 1.5 } }, copy.component.blocked_dataholder.message(dataHolder.brandName)),
                React__default.createElement(Typography, { sx: { mb: 1.5 } }, copy.component.blocked_dataholder.reason(dataHolder.brandName)),
                React__default.createElement(Typography, null, copy.component.blocked_dataholder.action(dataHolder.brandName))),
            React__default.createElement(Box, { sx: { pt: 3, display: 'flex', justifyContent: 'center' } },
                React__default.createElement(Button, { variant: "contained", color: "primary", onClick: handleClose }, "OK")))));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const ConsentTabs = ({ activeConsents = [], expiredConsents = [], revokedConsents = [], isLoading = false, urlPrefix = '/consent/', pagination, onChange, }) => {
    const [tabIndex, setTabIndex] = React__default.useState(0);
    const [paginationPage, setPaginationPage] = React__default.useState(1);
    const handleTabChange = (event, newTabIndex) => {
        event.stopPropagation();
        setTabIndex(newTabIndex);
        onChange(newTabIndex, paginationPage);
    };
    const handlePaginationChange = (page) => {
        setPaginationPage(page);
        onChange(tabIndex, page);
    };
    const noConsentItems = (status) => {
        return (React__default.createElement(Typography, { variant: "h5", sx: { py: 5, textAlign: 'center' } },
            "You do not have any ",
            status.toLocaleLowerCase(),
            " consents."));
    };
    return (React__default.createElement(Box, null,
        React__default.createElement(AppBar, { position: "static", color: "primary" },
            React__default.createElement(Tabs, { value: tabIndex, onChange: handleTabChange, indicatorColor: "secondary", textColor: "inherit", variant: "fullWidth", "aria-label": "Consent tabs" },
                React__default.createElement(Tab, Object.assign({ label: "Current" }, a11yProps(0))),
                React__default.createElement(Tab, Object.assign({ label: "Expired" }, a11yProps(1))),
                React__default.createElement(Tab, Object.assign({ label: "Revoked" }, a11yProps(2))))),
        React__default.createElement(TabPanel, { value: tabIndex, index: 0 },
            isLoading && renderLoading(),
            !isLoading && activeConsents.length > 0 && (React__default.createElement(Card, null,
                React__default.createElement(ConsentList, { consents: activeConsents, url: urlPrefix, onPagination: handlePaginationChange, pagination: pagination }))),
            !isLoading && activeConsents.length === 0 && noConsentItems(Status.Active)),
        React__default.createElement(TabPanel, { value: tabIndex, index: 1 },
            isLoading && renderLoading(),
            !isLoading && expiredConsents.length > 0 && (React__default.createElement(Card, null,
                React__default.createElement(ConsentList, { consents: expiredConsents, url: urlPrefix, onPagination: handlePaginationChange, pagination: pagination }))),
            !isLoading && expiredConsents.length === 0 && noConsentItems(Status.Expired)),
        React__default.createElement(TabPanel, { value: tabIndex, index: 2 },
            isLoading && renderLoading(),
            !isLoading && revokedConsents.length > 0 && (React__default.createElement(Card, null,
                React__default.createElement(ConsentList, { consents: revokedConsents, url: urlPrefix, onPagination: handlePaginationChange, pagination: pagination }))),
            !isLoading && revokedConsents.length === 0 && noConsentItems(Status.Revoked))));
};
const TabPanel = (props) => {
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return (React__default.createElement("div", Object.assign({ role: "tabpanel", hidden: value !== index, id: `Consent-tabpanel-${index}`, "aria-labelledby": `Consent-tab-${index}` }, other), value === index && React__default.createElement(Box, { sx: { px: { xs: 0, sm: 1, md: 3 }, py: { xs: 1, sm: 2, md: 3 } } }, children)));
};
const a11yProps = (index) => {
    return {
        id: `Consent-tab-${index}`,
        'aria-controls': `Consent-tabpanel-${index}`,
    };
};
const renderLoading = () => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Skeleton, { height: "80px" }),
        " ",
        React__default.createElement(Skeleton, { height: "80px" })));
};

const DataHolderHeader = (props) => {
    const { consent, editUrl = '', onRevokeClick } = props;
    let textDate = '';
    let granteeName = '';
    if (consent.grantee) {
        granteeName = `for ${consent.grantee.name} `;
    }
    switch (consent.status) {
        case Status.Active:
            textDate = `Consent ${granteeName}granted ${Formatter.formatDateTime(consent.created)}`;
            break;
        case Status.Requested:
            textDate = `Consent ${granteeName}requested ${Formatter.formatDateTime(consent.created)}`;
            break;
        case Status.Expired:
            textDate = `Consent ${granteeName}expired ${Formatter.formatDateTime(consent.sharingEndDate)}`;
            break;
        case Status.Revoked:
            textDate = `Consent ${granteeName}revoked ${Formatter.formatDateTime(consent.revoked)}`;
            break;
    }
    const handleonRevokeClick = () => {
        if (onRevokeClick) {
            onRevokeClick();
        }
    };
    return (React__default.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
        React__default.createElement(Box, null,
            React__default.createElement(Avatar, { alt: consent.dataHolderName, src: consent.dataHolderLogoUri, component: 'span', sx: { mr: 2, img: { height: 'auto' } }, variant: "square" },
                React__default.createElement(Bank, null))),
        React__default.createElement(Box, { sx: {
                display: 'flex',
                flex: '1',
                flexDirection: 'column',
                flexBasis: { xs: '100%', sm: 0 },
            } },
            React__default.createElement(Typography, { variant: "h2" }, consent.dataHolderName),
            React__default.createElement(Typography, { sx: { display: { xs: 'none', sm: 'block' } } }, textDate)),
        React__default.createElement(Box, { sx: {
                display: 'flex',
                flex: { xs: 1, sm: 'inherit' },
                alignItems: 'center',
                justifyContent: 'flex-end',
            } },
            consent.status === Status.Active && onRevokeClick && (React__default.createElement(React__default.Fragment, null,
                editUrl && (React__default.createElement(Tooltip, { content: "Edit consent", title: React__default.createElement(Link, { href: editUrl, sx: { display: 'inline-block' } },
                        React__default.createElement(IconButton, { sx: { mr: 1 } },
                            React__default.createElement(Pencil, { color: "button" }))) })),
                React__default.createElement(Tooltip, { content: "Revoke Data Access", title: React__default.createElement(IconButton, { onClick: handleonRevokeClick, sx: { mr: 1 } },
                        React__default.createElement(Delete, { color: "button" })) }))),
            consent.status !== Status.Active && (React__default.createElement(Chip, { label: consent.status, size: "small", sx: Object.assign(Object.assign(Object.assign({ color: 'common.white', fontWeight: 600, fontSize: '1.4rem', textTransform: 'lowercase', '& span:first-letter': {
                        textTransform: 'capitalize',
                    } }, (consent.status === Status.Expired && {
                    backgroundColor: 'warning.main',
                })), (consent.status === Status.Requested && {
                    backgroundColor: 'info.main',
                })), (consent.status === Status.Revoked && {
                    backgroundColor: 'error.main',
                })) })))));
};

const UseCaseSummary = (props) => {
    const { title, useCase } = props;
    const scopes = (React.createElement("ul", { className: "list" }, useCase.scopes &&
        useCase.scopes.map((scope) => {
            return (React.createElement("li", { key: scope.id },
                React.createElement(Typography, null, scope.name)));
        })));
    const purpose = useCase.description ? (React.createElement(React.Fragment, null,
        React.createElement(Typography, null, useCase.description))) : (React.createElement(React.Fragment, null,
        React.createElement(Typography, null, useCase.name)));
    return (React.createElement(Box, { sx: { mb: 4 } },
        React.createElement(Typography, { variant: "h2", sx: { mb: 2 } }, title),
        React.createElement(Accordion, { title: "Types of data received", content: scopes }),
        React.createElement(Accordion, { title: "Purpose of receiving data", content: purpose })));
};

const DateSummary = (props) => {
    const { title, consent } = props;
    let sharingEndDate = 'After first use';
    if (consent.useCase && consent.useCase.accessFrequency === AccessFrequency.Ongoing) {
        sharingEndDate = Formatter.formatDateTime(consent.sharingEndDate);
    }
    let firstDataCollection = 'Not yet';
    if (consent.firstDataCollection) {
        firstDataCollection = Formatter.formatDateTime(consent.firstDataCollection);
    }
    return (React.createElement(Box, { sx: { mb: 4 } },
        React.createElement(Typography, { variant: "h2", sx: { mb: 2 } }, title),
        React.createElement(Card, null,
            React.createElement(Typography, { variant: "h4", sx: { mb: 0.5 }, variantMapping: { h4: 'h3' } }, "When you gave consent"),
            React.createElement(Typography, { sx: { mb: 2 } }, Formatter.formatDateTime(consent.created)),
            React.createElement(Typography, { variant: "h4", sx: { mb: 0.5 }, variantMapping: { h4: 'h3' } }, "When we first collected your data"),
            React.createElement(Typography, { sx: { mb: 2 } }, firstDataCollection),
            React.createElement(Typography, { variant: "h4", sx: { mb: 0.5 }, variantMapping: { h4: 'h3' } }, "When your consent will expire"),
            React.createElement(Typography, { sx: { mb: 2 } }, sharingEndDate),
            consent.useCase && consent.useCase.accessFrequency && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "h4", sx: { mb: 0.5 }, variantMapping: { h4: 'h3' } }, "Data access frequency"),
                React.createElement(Typography, null, Helper.accessFrequencyToString(consent.useCase.accessFrequency)))))));
};

const DataHandlerList = (props) => {
    const { dataHandlers } = props;
    const [listItem, setListItem] = useState();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const handleInfoClick = (listItem) => {
        setListItem(listItem);
        setIsDialogOpen(true);
    };
    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(List, { sx: { width: '100%', bgcolor: 'background.paper', p: 0 } }, dataHandlers.map((dataHandler) => {
            return (React__default.createElement(ListItem, { key: dataHandler.name, sx: { px: 1, py: 0.5 } },
                React__default.createElement(ListItemText, { primary: React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: { xs: 'space-between', sm: 'normal' },
                            } },
                            React__default.createElement(Typography, { variant: "body2" }, dataHandler.name),
                            React__default.createElement(Box, { onClick: () => handleInfoClick(dataHandler), sx: { display: 'flex', alignItems: 'center' } },
                                React__default.createElement(InformationOutline, { sx: { mx: 1, cursor: 'pointer', color: '#66b0cc', fontSize: '18px' } })))) })));
        })),
        listItem && (React__default.createElement(Dialog, { onClose: handleDialogClose, open: isDialogOpen },
            React__default.createElement(DialogTitle, null,
                React__default.createElement("span", { style: { marginRight: '2rem' } }, listItem.name),
                React__default.createElement(IconButton, { "aria-label": "close", onClick: handleDialogClose, sx: {
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    } },
                    React__default.createElement(Close, null))),
            React__default.createElement(DialogContent, null,
                React__default.createElement(Typography, { sx: { mb: 1.5 } }, listItem.description))))));
};

const DataDisclosure = (props) => {
    const { dataRecipients } = props;
    const [copy] = useCopy();
    return (React.createElement(Box, { sx: { mb: 4 } },
        React.createElement(Typography, { variant: "h2", sx: { mb: 2 } }, copy.consent.details.data_disclosure_label),
        React.createElement(Card, null,
            React.createElement(Typography, { variant: "h3", sx: { mb: 1 } }, copy.consent.details.data_disclosure_message),
            React.createElement(DataHandlerList, { dataHandlers: dataRecipients }))));
};

const GranteeSummary = (props) => {
    const { gantee, status } = props;
    let text = gantee.name;
    switch (status) {
        case Status.Active:
            text = `${gantee.name} has your consent to access your data.`;
            break;
        case Status.Requested:
            text = `Your consent for ${gantee.name} to access your data is being processed.`;
            break;
        case Status.Expired:
            text = `Your consent for ${gantee.name} to access your data has expired.`;
            break;
        case Status.Revoked:
            text = `Your consent for ${gantee.name} to access has been revoked.`;
            break;
    }
    return (React.createElement(Box, { sx: { mb: 4 } },
        React.createElement(Typography, { variant: "h2", sx: { mb: 2 } }, "Who has access to my data"),
        React.createElement(Card, null, text)));
};

const BusinessConsumerStatement = () => {
    return (React.createElement(Box, { sx: { mb: 4 } },
        React.createElement(Card, null,
            React.createElement(Typography, null, "The consent is given for the purpose of providing a service to you in your capacity as a business (and not as an individual)."))));
};

const ConsentDetails = (props) => {
    const { consent, dateTitle, useCasetTitle, editUrl, dataRecipients, onRevokeClick } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { mb: 4 } },
            React.createElement(DataHolderHeader, { consent: consent, onRevokeClick: onRevokeClick, editUrl: editUrl })),
        Helper.isBcdc(dataRecipients) && Helper.isOrganisation(consent.useCase) && React.createElement(BusinessConsumerStatement, null),
        consent.grantee && React.createElement(GranteeSummary, { gantee: consent.grantee, status: consent.status }),
        consent.useCase && React.createElement(UseCaseSummary, { title: useCasetTitle, useCase: consent.useCase }),
        React.createElement(DateSummary, { title: dateTitle, consent: consent }),
        dataRecipients && React.createElement(DataDisclosure, { dataRecipients: dataRecipients })));
};

const ConsentSectionDeIdentify = (props) => {
    const { showError, onCheck } = props;
    const { primaryDataRecipient } = useDataRecipients();
    // JIRA ADA-3547: Hard coded for now
    const explanationMessage = "We'll combine your energy use data with that of others in your neighbourhood to calculate average numbers. These averages help you see how your energy use compares to other households in your area. We'll remove any personal information that could identify you - including your name, contact information, and physical address. The data used to create these averages will not be attributable to you, and you will not be able to elect that it be deleted.";
    const handleSwitchCheck = (value) => {
        onCheck(value);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { error: showError },
            React.createElement(SwitchDialog, { switchTitle: React.createElement(React.Fragment, null,
                    React.createElement(Highlight, null, primaryDataRecipient.name),
                    " requires your consent to combine your anonymised data with that of others in your area in order to calculate average numbers."), dialogTitle: 'De-identify', onCheck: handleSwitchCheck },
                React.createElement(React.Fragment, null, explanationMessage))),
        React.createElement(Typography, { sx: { mb: 1, minHeight: '2.2rem' }, variant: "body2", color: "error.main" }, showError && `Please confirm you would like to de-identify your data.`)));
};

const ConsentFormContext = React.createContext(undefined);
const useConsentForm = () => {
    const context = React.useContext(ConsentFormContext);
    if (!context) {
        throw new Error(`useConsentForm must be used within a ConsentFormProvider`);
    }
    return context;
};
const ConsentFormDefaultValues = {
    allAddScopesChecked: true,
    allRemoveScopesChecked: false,
    dataHolder: undefined,
    insightsConfirmation: false,
    selectedSharingDurations: undefined,
    postUsageAction: undefined,
    sharingEndDate: undefined,
    useCaseId: undefined,
};
const ConsentFormProvider = ({ children, initialValues = ConsentFormDefaultValues }) => {
    const [consent, setConsent] = React.useState(initialValues);
    return React.createElement(ConsentFormContext.Provider, { value: [consent, setConsent] }, children);
};

const DateSelector = (props) => {
    const { companyName, sharingDurations, showSharingDurationsOptions = false } = props;
    const [sharingEndDate, setSharingEndDate] = useState();
    const [sharingDuration, setSharingDuration] = useState();
    const [consentForm, setConsentForm] = useConsentForm();
    const handleDatePickerChange = (date) => {
        handleSharingEndDateChange(date, SharingDuration.Custom);
    };
    const handleDateButtonClick = (date, sharingDuration) => {
        handleSharingEndDateChange(date, sharingDuration);
    };
    const handleSharingEndDateChange = (date, selectedSharingDuration) => {
        consentForm.selectedSharingDurations = selectedSharingDuration;
        consentForm.sharingEndDate = date;
        setConsentForm(Object.assign({}, consentForm));
        setSharingEndDate(date);
        setSharingDuration(selectedSharingDuration);
    };
    let showAllOptions = showSharingDurationsOptions;
    if (sharingDurations.length === 1 && sharingDurations[0] === SharingDuration.OnceOff) {
        showAllOptions = false;
    }
    useEffect(() => {
        if (sharingDurations.length === 1 &&
            sharingDurations[0] !== SharingDuration.OnceOff &&
            sharingDurations[0] !== SharingDuration.Custom) {
            const dateDurations = Helper.parseSharingDurations(sharingDurations);
            handleDateButtonClick(Helper.dateDurationToDate(dateDurations[0]), dateDurations[0].type);
        }
    }, []);
    return (React__default.createElement(React__default.Fragment, null,
        (showAllOptions || sharingDurations.length > 1 || sharingDurations.includes(SharingDuration.Custom)) && (React__default.createElement(Typography, { sx: { mb: 2 } },
            "How long would you like ",
            React__default.createElement(Highlight, null, companyName),
            " to be able to access your data?")),
        !showAllOptions && sharingDurations.length === 1 && sharingDurations.includes(SharingDuration.OnceOff) && (React__default.createElement(Typography, { sx: { mb: 1.5 } },
            React__default.createElement(Highlight, null, companyName),
            " will be able to access your data ",
            React__default.createElement(Highlight, null, "once"),
            ".")),
        (showAllOptions || sharingDurations.length > 1) && (React__default.createElement(Box, { sx: { mt: 2, display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } } },
            React__default.createElement(DateButton, { sharingDurations: sharingDurations, onClick: handleDateButtonClick, selectedSharingDuration: sharingDuration }))),
        sharingDurations.includes(SharingDuration.Custom) && sharingDurations.length > 1 && (React__default.createElement(Typography, { variant: "body2", sx: {
                mt: 1,
                mr: { xs: 0, sm: 12 },
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-end' },
            } }, "or")),
        sharingDurations.includes(SharingDuration.Custom) && (React__default.createElement(Box, { sx: {
                mt: 2,
                display: 'flex',
                width: { xs: '100%', sm: 'inherit' },
                justifyContent: { xs: 'center', sm: 'flex-end' },
            } },
            React__default.createElement(DatePicker, { date: sharingEndDate, label: "Expire on", onChange: handleDatePickerChange }))),
        sharingEndDate && sharingDuration === SharingDuration.Custom && (React__default.createElement(Typography, { sx: { my: 1.5 } },
            React__default.createElement(Highlight, null, companyName),
            " will be able to access your data until the",
            ' ',
            React__default.createElement(Highlight, null, Formatter.formatDateTime(sharingEndDate)),
            ".")),
        sharingDuration && sharingDuration !== SharingDuration.Custom && (React__default.createElement(Typography, { sx: { my: 1.5 } },
            React__default.createElement(Highlight, null, companyName),
            " will be able to access your data",
            ' ',
            sharingDuration === SharingDuration.OnceOff && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Highlight, null, "once"),
                ".")),
            sharingDuration !== SharingDuration.OnceOff && (React__default.createElement(React__default.Fragment, null,
                "for ",
                React__default.createElement(Highlight, null, Helper.sharingDurationToString(sharingDuration)),
                "."))))));
};

const ErrorMessage = (props) => {
    const { message, code, data, timeStamp = new Date(), type = 'UNKNOWN', supportContact, url, userMessage = 'We are sorry but it looks like an error has occurred.', } = props;
    const theme = useTheme();
    const bgCode = theme.palette.mode === 'light' ? '#F6F6F6' : '#444B5C';
    const iconFontSize = '56px';
    let parsedData = undefined;
    if (typeof data === 'string') {
        parsedData = data;
    }
    else {
        parsedData = JSON.stringify(data);
    }
    const errorDetails = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Typography, { sx: { mb: 2 }, variant: "h2" },
            "Error: ",
            message),
        type && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { variant: "h5" }, "Type"),
            React__default.createElement(Typography, { sx: { mb: 2 } }, type))),
        code && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { variant: "h5" }, "Code"),
            React__default.createElement(Typography, { sx: { mb: 2 } }, code))),
        url && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { variant: "h5" }, "URL"),
            React__default.createElement(Typography, { sx: { mb: 2, wordBreak: 'break-all' } }, url))),
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { variant: "h5" }, "Time"),
            React__default.createElement(Typography, { sx: { mb: 2 } }, Formatter.formatDateTimeTz(timeStamp))),
        parsedData && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { variant: "h5" }, "Extra information"),
            React__default.createElement(Box, { sx: {
                    display: 'block',
                    width: { xs: 'calc(100vw - 125px)', sm: 'calc(100vw - 175px)', md: 'auto' },
                    overflow: 'scroll',
                    backgroundColor: bgCode,
                } },
                React__default.createElement("pre", { style: { padding: '8px' } }, parsedData))))));
    const body = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Typography, null, "Please try reloading the page."),
        supportContact && (React__default.createElement(Typography, { sx: { mt: 2 } },
            "If the problem continues please contact the support team: ",
            supportContact)),
        React__default.createElement(Box, { sx: { mt: 4, width: '100%' } },
            React__default.createElement(Accordion, { title: 'Show error details', content: errorDetails }))));
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(FeedbackMessage, { message: userMessage, icon: React__default.createElement(AlertCircle, { sx: { fontSize: iconFontSize, color: 'error.main' } }) }, body)));
};

const InsightConfirmationForm = (props) => {
    const { insightScopes, dataHolderName, onChange, showError = false } = props;
    const { nonAdrDataRecipient } = useDataRecipients();
    const handleConfirmationChange = (event, checked) => {
        event.stopPropagation();
        onChange(checked);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Box, { sx: { mb: 3 } },
            React__default.createElement(Typography, { sx: { mb: 1, textAlign: { xs: 'center', sm: 'left' } }, variant: "h2" },
                React__default.createElement(Highlight, null, nonAdrDataRecipient === null || nonAdrDataRecipient === void 0 ? void 0 : nonAdrDataRecipient.name),
                " needs your permission to receive the following insights:")),
        React__default.createElement(Card, { error: showError, sx: { mt: 1 } },
            React__default.createElement(InsightList, { insightScopes: insightScopes, dataHolderName: dataHolderName }),
            React__default.createElement(Box, { sx: { mt: 1.5, pr: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' } },
                React__default.createElement(FormControlLabel, { labelPlacement: "start", control: React__default.createElement(Checkbox, { color: "button", onChange: handleConfirmationChange }), label: React__default.createElement(Typography, null,
                        "I confirm that ",
                        React__default.createElement(Highlight, null, nonAdrDataRecipient === null || nonAdrDataRecipient === void 0 ? void 0 : nonAdrDataRecipient.name),
                        " has permission to receive the above insights.") }))),
        React__default.createElement(Typography, { sx: { mb: 1, minHeight: '2.2rem' }, variant: "body2", color: "error.main" }, showError && 'Please select the confirmation box.')));
};

const RevokeDialog = (props) => {
    const { isOpen, isLoading, dataHolderName, onCancelClick, onRevokeClick } = props;
    const handleRevokeDialogClose = () => {
        onCancelClick();
    };
    const handleRevokeDialogButtonClick = () => {
        onRevokeClick();
    };
    return (React.createElement(Dialog, { open: isOpen, onClose: handleRevokeDialogClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
        React.createElement(React.Fragment, null,
            React.createElement(DialogTitle, { id: "alert-dialog-title" }, 'Are you sure you want to revoke this consent?'),
            React.createElement(DialogContent, null,
                isLoading && (React.createElement(Box, { sx: { top: 'calc(50% - 30px)', position: 'absolute', left: 'calc(50% - 30px)' } },
                    React.createElement(CircularProgress, { sx: { m: 1, color: 'primary.main' }, "aria-label": "Loading", size: 60 }))),
                React.createElement(DialogContentText, { id: "alert-dialog-description", sx: { visibility: isLoading === true ? 'hidden' : 'visible', color: 'text_main.main' } }, `Revoking access will ensure that we are no longer able to receive your data from ${dataHolderName}.
    Any revocation will take impact immediately. If you revoke consent, our service to you may be impacted.`))),
        React.createElement(DialogActions, { sx: { p: 2 } },
            React.createElement(Button, { onClick: handleRevokeDialogClose, disabled: isLoading, color: "inherit" }, "Cancel"),
            React.createElement(Button, { onClick: handleRevokeDialogButtonClick, autoFocus: true, variant: "contained", color: "button", disabled: isLoading }, "Revoke"))));
};

const SupportingParties = (props) => {
    const { title, useCase, outsourcedServiceProviders } = props;
    return (React.createElement(Accordion, { title: title, content: React.createElement(React.Fragment, null,
            React.createElement(Typography, { sx: { mb: 0.5 } },
                "Supporting Parties help operate this service. They can access the data you have agreed to share with us but only for ",
                useCase.name,
                "."),
            React.createElement(Typography, { sx: { mb: 2 } }, "The below parties help provide this service:"),
            outsourcedServiceProviders.map((osp) => {
                return (React.createElement(Box, { sx: { mb: 3 }, key: osp.providerName },
                    React.createElement(Typography, { variant: "h5" }, osp.providerName),
                    osp.accreditationId && (React.createElement(Typography, { sx: { mb: 1 }, variant: "body2" },
                        "Accredited ID: ",
                        osp.accreditationId)),
                    osp.serviceDescription && React.createElement(Typography, { sx: { mb: 1 } }, osp.serviceDescription),
                    osp.cdrPolicyUri && (React.createElement(Typography, { sx: { mt: 0.5, mb: 1 } },
                        "Learn more about how they do this in the",
                        ' ',
                        React.createElement(LinkExternal, { href: osp.cdrPolicyUri, text: `${osp.providerName} CDR Policy` }),
                        "."))));
            })) }));
};

const UseCaseSelector = (props) => {
    const { useCases, onChange } = props;
    let radioButtonItems = [];
    if (useCases) {
        radioButtonItems = useCases.map((useCase) => {
            var _a, _b, _c;
            return { label: (_a = useCase.name) !== null && _a !== void 0 ? _a : '', value: (_b = useCase.id) !== null && _b !== void 0 ? _b : '', description: (_c = useCase.description) !== null && _c !== void 0 ? _c : '' };
        });
    }
    const handleRadioCheck = (useCaseId) => {
        onChange(useCaseId);
    };
    return (React.createElement(Card, null,
        React.createElement(RadioButtonWithText, { radioButtonItems: radioButtonItems, onChange: handleRadioCheck })));
};

const ConsentInputDataHolder = (props) => {
    const { disableDataHolders, favouriteDataHolders, useCase, blockedDataHolderList = [], onNotListedClick, onCancel, } = props;
    const [showDataHolderError, setShowDataHolderError] = useState(false);
    const [consentForm, setConsentForm] = useConsentForm();
    const [copy] = useCopy();
    const [blockedDataHolder, setBlockedDataHolder] = useState(undefined);
    const [isblockedDialogOpen, setBlockedDialogOpen] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const isDataHolderBlocked = (dataHolder) => {
        const isBlocked = blockedDataHolderList.length >= 1 &&
            blockedDataHolderList.filter((blocked) => dataHolder.dataHolderBrandId === blocked.dataHolderBrandId).length > 0;
        return isBlocked;
    };
    const handleDataHolderChange = (dataHolder) => {
        if (dataHolder === null) {
            consentForm.dataHolder = undefined;
        }
        else if (dataHolder.dataHolderBrandId === 'not-listed') {
            if (onNotListedClick) {
                onNotListedClick();
            }
        }
        else if (isDataHolderBlocked(dataHolder)) {
            Logger.warn(`Data holder blocking enabled for ${dataHolder.brandName}, full list of blocked IDs`, blockedDataHolderList);
            setBlockedDataHolder(dataHolder);
            setBlockedDialogOpen(true);
            consentForm.dataHolder = undefined;
        }
        else {
            setShowDataHolderError(false);
            consentForm.dataHolder = dataHolder;
        }
        setConsentForm(Object.assign({}, consentForm));
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Box, { sx: { mb: 3 } },
            React__default.createElement(Typography, { variant: "h2" }, copy.consent.create.select_favourite_data_holder_title)),
        useCase.dataHolders && (React__default.createElement(React__default.Fragment, null,
            favouriteDataHolders && favouriteDataHolders.length > 0 && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(DataHolderTiles, { dataHolders: favouriteDataHolders, onClick: handleDataHolderChange, disableDataHolders: disableDataHolders }),
                React__default.createElement(Box, { sx: { mt: 3, mb: 1 } },
                    React__default.createElement(Typography, { variant: "h3" }, copy.consent.create.select_more_data_holder_title)))),
            React__default.createElement(AutocompleteDropdown, { dataHolders: useCase.dataHolders, disableDataHolders: disableDataHolders, onChange: handleDataHolderChange, showError: showDataHolderError, label: copy.consent.create.data_holder_input_label, showNotListed: onNotListedClick !== undefined }),
            blockedDataHolderList.length >= 1 && blockedDataHolder && (React__default.createElement(BlockedDataholderDialog, { dataHolder: blockedDataHolder, isOpen: isblockedDialogOpen, onClose: () => {
                    setBlockedDialogOpen(false);
                    setBlockedDataHolder(undefined);
                } })))),
        React__default.createElement(Button, { variant: "outlined", color: "inherit", onClick: onCancel, sx: { mt: 2 } }, "Cancel")));
};

const ConsentSectionHeader = (props) => {
    const { dataHolderName, subTitle } = props;
    const [copy] = useCopy();
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { mb: 3 } },
            React.createElement(Typography, { sx: { mb: 1, textAlign: { xs: 'center', sm: 'left' } }, variant: "h2" }, copy.consent.create.title(dataHolderName)),
            subTitle && (React.createElement(Typography, { sx: { mb: 1, textAlign: { xs: 'center', sm: 'left' } }, variant: "body2" }, subTitle)))));
};

const ConsentSectionScopes = (props) => {
    const { message, showError, scopes, readOnly = true, onChange } = props;
    const handleChange = (isAllClicked) => {
        if (onChange) {
            onChange(isAllClicked);
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Card, { error: showError, sx: { mt: 1 } },
            React__default.createElement(Typography, { sx: { mb: 1 } }, message),
            readOnly && React__default.createElement(ScopeList, { scopes: scopes }),
            !readOnly && React__default.createElement(ScopeListSwitch, { scopes: scopes, onChange: handleChange })),
        React__default.createElement(Typography, { sx: { mb: 1, minHeight: '2.2rem' }, variant: "body2", color: "error.main" }, showError && !readOnly && 'Please select all the options.')));
};

const ConsentSectionDates = (props) => {
    const { useCase, showError, showSharingDurationsOptions = false } = props;
    const { primaryDataRecipient } = useDataRecipients();
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { error: showError },
            useCase.sharingDurations && (React.createElement(DateSelector, { companyName: primaryDataRecipient.name, sharingDurations: useCase.sharingDurations, showSharingDurationsOptions: showSharingDurationsOptions })),
            React.createElement(Typography, { sx: { mt: 1.5, mb: 0 } }, TextBuilder.accessFrequency(primaryDataRecipient.name, useCase.accessFrequency))),
        React.createElement(Typography, { sx: { mb: 1, minHeight: '2.2rem' }, variant: "body2", color: "error.main" }, showError && `Please confirm how long you would like ${primaryDataRecipient.name} to access your data.`)));
};

const ConsentSectionInfo = (props) => {
    const { useCase, dataHandlers } = props;
    const getHideDuplicates = () => {
        let hideDuplicates = false;
        const isNonAdr = isNonADR();
        if (isNonAdr) {
            hideDuplicates = false;
        }
        else if (!isNonAdr && dataHandlers && dataHandlers.length >= 1) {
            hideDuplicates = true;
        }
        return hideDuplicates;
    };
    const isNonADR = () => {
        const nonAdrFound = dataHandlers === null || dataHandlers === void 0 ? void 0 : dataHandlers.find((dataHandler) => {
            return dataHandler.type === DataRecipientType.NON_ACCREDITED_PERSON;
        });
        return nonAdrFound !== undefined;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { mb: 4, position: 'relative' } },
            React.createElement(GeneralInformation, { hideDuplicateListItem: getHideDuplicates() }),
            !isNonADR() && (React.createElement(Accordion, { title: "What is the purpose of accessing my data?", content: React.createElement(Typography, { variant: "body1" }, useCase.description) })),
            dataHandlers && dataHandlers.length > 0 && React.createElement(DataHandlingInfo, { dataHandlers: dataHandlers }),
            useCase.osps && useCase.osps.length > 0 && (React.createElement(SupportingParties, { title: 'Supporting Parties', useCase: useCase, outsourcedServiceProviders: useCase.osps })))));
};

const ConsentSectionActions = (props) => {
    const { actionButtonLabel, cancelButtonLabel, cancelButtonMessage, isValid, showError, onCancel, onSubmit } = props;
    const { accreditationNumber, primaryDataRecipient, adrDataRecipient } = useDataRecipients();
    const accreditationName = primaryDataRecipient.type === DataRecipientType.CDR_REPRESENTATIVE
        ? primaryDataRecipient.name
        : adrDataRecipient.name;
    const handleSubmit = () => {
        onSubmit();
    };
    const handleCancel = () => {
        onCancel();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row-reverse' },
            } },
            React.createElement(Button, { sx: { mb: 2, width: { xs: '100%', sm: '17rem' } }, variant: "contained", color: isValid === true ? 'button' : 'inherit', onClick: handleSubmit }, actionButtonLabel),
            React.createElement(ConsentCancelButton, { label: cancelButtonLabel, dialogText: cancelButtonMessage, onCancel: handleCancel })),
        React.createElement(Typography, { sx: { mb: 3, minHeight: '2.2rem' }, variant: "body2", color: "error.main" }, showError && !isValid && 'Please fix the error(s) above.'),
        React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center' } },
            React.createElement(Accreditation, { accreditationNumber: accreditationNumber, companyName: accreditationName, underCdrPrincipal: primaryDataRecipient.type === DataRecipientType.CDR_REPRESENTATIVE }))));
};

const PartnerMessageDialog = (props) => {
    const { dataHolderName, isOpen, discreetMode = false, onClose, onSubmit } = props;
    const handleClose = () => {
        onClose();
    };
    const handleSubmit = () => {
        onSubmit();
    };
    return (React__default.createElement(Dialog, { open: isOpen, "aria-labelledby": "partner-dialog-title", "aria-describedby": "partner-dialog-description" },
        React__default.createElement(DialogContent, null,
            React__default.createElement(IconButton, { "aria-label": "close", onClick: handleClose, sx: {
                    position: 'absolute',
                    right: { xs: 4, sm: 8 },
                    top: { xs: 4, sm: 8 },
                    color: (theme) => theme.palette.button.light,
                } },
                React__default.createElement(Close, null)),
            React__default.createElement(PartnerMessage, { dataHolderName: dataHolderName, discreetMode: discreetMode }),
            React__default.createElement(Box, { sx: { pt: 3, display: 'flex', justifyContent: 'center' } },
                React__default.createElement(Button, { variant: "contained", color: "primary", onClick: handleSubmit }, "OK")))));
};

var UseCaseFeature;
(function (UseCaseFeature) {
    UseCaseFeature["CDR_INSIGHTS"] = "CDRInsights";
    UseCaseFeature["DE_IDENTIFICATION"] = "DE_IDENTIFICATION";
})(UseCaseFeature || (UseCaseFeature = {}));

const ConsentCreateInsight = ({ nonAdrDataRecipient, primaryDataRecipient, useCase, }) => {
    var _a;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Box, { sx: { mb: 3 } },
            React__default.createElement(Typography, { sx: { mb: 1.6, textAlign: { xs: 'center', sm: 'left' } }, variant: "h2" },
                React__default.createElement(Highlight, null, useCase.name))),
        React__default.createElement(Card, { sx: { mb: 3.6 } },
            React__default.createElement(Typography, { sx: { mb: 1.6, textAlign: { xs: 'center', sm: 'left' } } },
                React__default.createElement(Highlight, null, nonAdrDataRecipient.name),
                " requires your consent to ",
                useCase.name,
                "."),
            useCase.description && (React__default.createElement(Typography, { sx: { mb: 1.6, textAlign: { xs: 'center', sm: 'left' } } }, useCase.description)),
            React__default.createElement(Typography, { variant: "body2", sx: { color: (theme) => lighten(theme.palette.text_main.main, 0.3) } },
                nonAdrDataRecipient.name,
                " is the Insight recipient. ",
                nonAdrDataRecipient.name,
                " has partnered with",
                ' ',
                primaryDataRecipient.name,
                " to securely access your ", (_a = useCase.industries) === null || _a === void 0 ? void 0 :
                _a.toString().toLocaleLowerCase(),
                " data and generate the Insight \u201C",
                useCase.name,
                "\u201D. ",
                primaryDataRecipient.name,
                " will only share the generated Insight with ",
                nonAdrDataRecipient.name,
                "."))));
};

const ConsentCreateForm = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const { useCase, enablePartnerMessageDiscreetMode = false, dataHandlers, onCancel, onSubmit } = props;
    const [isFormValid, setIsFormValid] = useState(false);
    const [isPartnerDialogOpen, setIsPartnerDialogOpen] = useState(false);
    const [showDataHolderError, setShowDataHolderError] = useState(false);
    const [showDateError, setShowDateError] = useState(false);
    const [showScopeError, setShowScopeError] = useState(false);
    const [showDeIdentifyError, setShowDeIdentifyError] = useState(false);
    const [showDeIdentifySection, setShowDeIdentifySection] = useState(false);
    const [showInsights, setShowInsights] = useState(false);
    const [consentForm, setConsentForm] = useConsentForm();
    const [copy] = useCopy();
    const { primaryDataRecipient, nonAdrDataRecipient, dataRecipients } = useDataRecipients();
    const dataHandlersWithoutPrimary = dataHandlers === null || dataHandlers === void 0 ? void 0 : dataHandlers.filter((dataRecipient) => {
        return dataRecipient.type !== primaryDataRecipient.type;
    });
    useEffect(() => {
        var _a;
        window.scrollTo(0, 0);
        if (useCase.sharingDurations &&
            useCase.sharingDurations.length === 1 &&
            !useCase.sharingDurations.includes(SharingDuration.Custom)) {
            consentForm.selectedSharingDurations = useCase.sharingDurations[0];
            consentForm.sharingEndDate = Helper.sharingDurationToDate(useCase.sharingDurations[0]);
            setConsentForm(Object.assign({}, consentForm));
        }
        if ((_a = useCase.features) === null || _a === void 0 ? void 0 : _a.includes(UseCaseFeature.CDR_INSIGHTS)) {
            setShowInsights(true);
        }
        // @ts-ignore
        if (useCase.features &&
            Array.isArray(useCase.features) &&
            useCase.features.includes(UseCaseFeature.DE_IDENTIFICATION)) {
            consentForm.postUsageAction = undefined;
            setConsentForm(Object.assign({}, consentForm));
            setShowDeIdentifySection(true);
        }
        else {
            consentForm.postUsageAction = PostUsageAction.Deletion;
            setConsentForm(Object.assign({}, consentForm));
        }
    }, []);
    useEffect(() => {
        if (consentForm.selectedSharingDurations) {
            setShowDateError(false);
        }
        if (consentForm.allAddScopesChecked &&
            consentForm.dataHolder &&
            consentForm.selectedSharingDurations &&
            consentForm.postUsageAction) {
            setIsFormValid(true);
        }
        else {
            setIsFormValid(false);
        }
    }, [consentForm]);
    const handlePartnerDialogClose = () => {
        setIsPartnerDialogOpen(false);
    };
    const handleCancel = () => {
        onCancel();
    };
    const handlePreSubmit = () => {
        setIsPartnerDialogOpen(false);
        if (isFormValid) {
            if (primaryDataRecipient.type === DataRecipientType.CDR_REPRESENTATIVE ||
                primaryDataRecipient.type === DataRecipientType.BUSINESS_CONSUMER_DISCLOSURE_CONSENT) {
                setIsPartnerDialogOpen(true);
            }
            else {
                handleSubmit();
            }
        }
        else {
            setShowDataHolderError(!consentForm.dataHolder);
            setShowDateError(!consentForm.selectedSharingDurations);
            setShowDeIdentifyError(!consentForm.postUsageAction);
            setShowScopeError(consentForm.allAddScopesChecked === true ? false : true);
        }
    };
    const handleScopeChange = (isAllClicked) => {
        consentForm.allAddScopesChecked = isAllClicked;
        setConsentForm(Object.assign({}, consentForm));
        setShowScopeError(false);
    };
    const handleDeIdentifyChange = (value) => {
        if (value) {
            consentForm.postUsageAction = PostUsageAction.DeIdentification;
        }
        else {
            consentForm.postUsageAction = undefined;
        }
        setConsentForm(Object.assign({}, consentForm));
        setShowDeIdentifyError(false);
    };
    const handleSubmit = () => {
        onSubmit();
    };
    return (React__default.createElement("section", null,
        useCase.dataHolders && useCase.scopes && (React__default.createElement(React__default.Fragment, null,
            showInsights && nonAdrDataRecipient && (React__default.createElement(ConsentCreateInsight, { useCase: useCase, nonAdrDataRecipient: nonAdrDataRecipient, primaryDataRecipient: primaryDataRecipient, dataHolderName: ((_a = consentForm.dataHolder) === null || _a === void 0 ? void 0 : _a.brandName) === undefined ? ' ' : (_b = consentForm.dataHolder) === null || _b === void 0 ? void 0 : _b.brandName })),
            !showInsights && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(ConsentSectionHeader, { dataHolderName: ((_c = consentForm.dataHolder) === null || _c === void 0 ? void 0 : _c.brandName) === undefined ? ' ' : (_d = consentForm.dataHolder) === null || _d === void 0 ? void 0 : _d.brandName }))),
            React__default.createElement(ConsentSectionScopes, { message: showInsights
                    ? copy.consent.edit.scope_for_insights_create_message((_e = useCase.name) !== null && _e !== void 0 ? _e : 'to generate the insight')
                    : copy.consent.edit.scope_create_message, scopes: useCase.scopes, showError: showScopeError, onChange: handleScopeChange }),
            Helper.isBcdc(dataRecipients) && Helper.isOrganisation(useCase) && React__default.createElement(BusinessConsumerStatement, null),
            showDeIdentifySection && (React__default.createElement(ConsentSectionDeIdentify, { showError: showDeIdentifyError, onCheck: handleDeIdentifyChange })),
            React__default.createElement(ConsentSectionDates, { useCase: useCase, showError: showDateError }),
            React__default.createElement(ConsentSectionInfo, { useCase: useCase, dataHandlers: dataHandlersWithoutPrimary }),
            React__default.createElement(ConsentSectionActions, { actionButtonLabel: copy.consent.create.consent_label, cancelButtonLabel: copy.consent.create.cancel_label, cancelButtonMessage: copy.consent.create.cancel_consent_message, isValid: isFormValid, showError: showDataHolderError || showDateError || showScopeError, onCancel: handleCancel, onSubmit: handlePreSubmit }))),
        React__default.createElement(PartnerMessageDialog, { dataHolderName: consentForm.dataHolder ? (_f = consentForm.dataHolder) === null || _f === void 0 ? void 0 : _f.brandName : copy.common.fallback_data_holder_name, discreetMode: enablePartnerMessageDiscreetMode, isOpen: isPartnerDialogOpen, onClose: handlePartnerDialogClose, onSubmit: handleSubmit })));
};

const ConsentCreate = (props) => {
    const { existingConsents, useCase, blockedDataHolderList = [], enablePartnerMessageDiscreetMode = false, dataHolderId, favouriteDataHolders, hideMaxAccountConnectedBackButton = false, allowMultiConsentsPerDataHolder = false, onCancel, onSubmit, onNotListedClick, } = props;
    const [consentForm, setConsentForm] = useConsentForm();
    const { dataRecipients } = useDataRecipients();
    let disableDataHolders = [];
    useEffect(() => {
        if (dataHolderId && useCase && useCase.dataHolders) {
            const foundDataHolder = useCase.dataHolders.find((dataHolder) => {
                return dataHolderId === dataHolder.dataHolderBrandId;
            });
            if (foundDataHolder) {
                consentForm.dataHolder = foundDataHolder;
                setConsentForm(Object.assign({}, consentForm));
            }
            if (!foundDataHolder) {
                Logger.error(`Data holder ID ${dataHolderId} is not in use case allowed data holders`, useCase.dataHolders);
            }
        }
    }, []);
    if (!allowMultiConsentsPerDataHolder) {
        disableDataHolders = Helper.filterDataHoldersByConsentsAndUseCase(useCase.dataHolders, existingConsents, useCase);
    }
    const handleCancel = () => {
        onCancel();
    };
    const handleSubmit = () => {
        onSubmit();
    };
    return (React__default.createElement("section", null,
        useCase.dataHolders && useCase.scopes && useCase.dataHolders.length > disableDataHolders.length && (React__default.createElement(React__default.Fragment, null,
            !consentForm.dataHolder && (React__default.createElement(ConsentInputDataHolder, { disableDataHolders: disableDataHolders, useCase: useCase, favouriteDataHolders: favouriteDataHolders, blockedDataHolderList: blockedDataHolderList, onCancel: handleCancel, onNotListedClick: onNotListedClick })),
            consentForm.dataHolder && (React__default.createElement(ConsentCreateForm, { enablePartnerMessageDiscreetMode: enablePartnerMessageDiscreetMode, useCase: useCase, dataHandlers: dataRecipients, onCancel: handleCancel, onSubmit: handleSubmit })))),
        useCase.dataHolders && useCase.dataHolders.length === disableDataHolders.length && (React__default.createElement(MaxAccountConnectedMessage, { useCase: useCase, hideBackButton: hideMaxAccountConnectedBackButton, onClick: handleCancel }))));
};

const ConsentEditDates = (props) => {
    const { consent, showError = false, useCase, showSharingDurationsOptions = false } = props;
    const { primaryDataRecipient } = useDataRecipients();
    const singleDateExtention = useCase.sharingDurations &&
        useCase.sharingDurations.length === 1 &&
        useCase.sharingDurations[0] !== SharingDuration.Custom &&
        useCase.sharingDurations[0] !== SharingDuration.OnceOff;
    return (React__default.createElement("section", null,
        React__default.createElement(Card, null,
            React__default.createElement(Typography, { variant: "h2", sx: { mt: 1.5, mb: 0 } }, "Extend data access period"),
            React__default.createElement(Typography, { sx: { mt: 1.5, mb: 0 } }, TextBuilder.currentAccess(primaryDataRecipient.name, consent.sharingEndDate)),
            singleDateExtention && useCase && useCase.sharingDurations && (React__default.createElement(Typography, { sx: { mt: 1.5, mb: 0 } },
                `${primaryDataRecipient.name} would like to extend their access period to your data until the `,
                React__default.createElement(Highlight, null, `${Formatter.formatDateTime(Helper.sharingDurationToDate(useCase.sharingDurations[0]))}.`))),
            !singleDateExtention && (React__default.createElement(Typography, { sx: { mt: 1.5, mb: 0 } }, `${primaryDataRecipient.name} would like to extend their access period to your data.`))),
        React__default.createElement(ConsentSectionDates, { useCase: useCase, showError: showError, showSharingDurationsOptions: showSharingDurationsOptions })));
};

const ConsentEdit = (props) => {
    var _a;
    const { consent, useCase, enablePartnerMessageDiscreetMode = false, onCancel, onSubmit } = props;
    const [isEditable] = useState(consent.status === Status.Active);
    const [isPartnerDialogOpen, setIsPartnerDialogOpen] = useState(false);
    const [consentForm] = useConsentForm();
    const [copy] = useCopy();
    const { primaryDataRecipient } = useDataRecipients();
    const { dataRecipients } = useDataRecipients();
    const handlePartnerDialogClose = () => {
        setIsPartnerDialogOpen(false);
    };
    const handleCancel = () => {
        onCancel();
    };
    const handlePreSubmit = () => {
        setIsPartnerDialogOpen(false);
        if (primaryDataRecipient.type === DataRecipientType.CDR_REPRESENTATIVE ||
            primaryDataRecipient.type === DataRecipientType.BUSINESS_CONSUMER_DISCLOSURE_CONSENT) {
            setIsPartnerDialogOpen(true);
        }
        else {
            handleSubmit();
        }
    };
    const handleSubmit = () => {
        onSubmit();
    };
    return (React__default.createElement("section", null,
        React__default.createElement(Box, { sx: { mb: 3 } }, !isEditable && consent.status && (React__default.createElement(Alert, { severity: "error" },
            React__default.createElement(Typography, null, copy.consent.edit.non_active_consent_message(consent.status.toLowerCase()))))),
        isEditable && (React__default.createElement(Box, { sx: { mb: 3 } },
            React__default.createElement(Typography, { sx: { mb: 1, textAlign: { xs: 'center', sm: 'left' } }, variant: "h2" }, copy.consent.edit.active_consent_message))),
        consent.useCase && consent.useCase.scopes && (React__default.createElement("section", null,
            React__default.createElement(ConsentSectionScopes, { message: copy.consent.edit.scope_read_only_message, readOnly: true, scopes: consent.useCase.scopes, showError: false }))),
        isEditable && React__default.createElement(ConsentEditDates, { consent: consent, showError: false, useCase: useCase }),
        React__default.createElement(ConsentSectionInfo, { useCase: useCase, dataHandlers: dataRecipients }),
        !isEditable && (React__default.createElement(Box, { sx: { display: 'flex', justifyContent: 'flex-end' } },
            React__default.createElement(Button, { variant: "contained", onClick: handleCancel, sx: { width: { xs: '100%', sm: '20rem' } } }, copy.common.button_label_finished))),
        isEditable && (React__default.createElement(ConsentSectionActions, { actionButtonLabel: copy.consent.create.save_label, cancelButtonLabel: copy.consent.create.cancel_label, cancelButtonMessage: copy.consent.create.cancel_edit_message, isValid: true, showError: false, onCancel: handleCancel, onSubmit: handlePreSubmit })),
        React__default.createElement(PartnerMessageDialog, { dataHolderName: consentForm.dataHolder ? (_a = consentForm.dataHolder) === null || _a === void 0 ? void 0 : _a.brandName : copy.common.fallback_data_holder_name, discreetMode: enablePartnerMessageDiscreetMode, isOpen: isPartnerDialogOpen, onClose: handlePartnerDialogClose, onSubmit: handleSubmit })));
};

const ApiCogIcon = (props) => {
    const { textColor = '#fff' } = props;
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M20.405,13.067c0.045,-0.352 0.079,-0.704 0.079,-1.067c-0,-0.363 -0.034,-0.726 -0.079,-1.1l2.386,-1.793c0.215,-0.165 0.271,-0.462 0.136,-0.704l-2.262,-3.806c-0.136,-0.242 -0.441,-0.341 -0.69,-0.242l-2.816,1.1c-0.588,-0.429 -1.198,-0.803 -1.911,-1.078l-0.418,-2.915c-0.046,-0.264 -0.283,-0.462 -0.566,-0.462l-4.523,0c-0.283,0 -0.52,0.198 -0.566,0.462l-0.418,2.915c-0.713,0.275 -1.323,0.649 -1.911,1.078l-2.816,-1.1c-0.249,-0.099 -0.554,0 -0.69,0.242l-2.262,3.806c-0.147,0.242 -0.079,0.539 0.136,0.704l2.386,1.793c-0.045,0.374 -0.079,0.737 -0.079,1.1c0,0.363 0.034,0.715 0.079,1.067l-2.386,1.826c-0.215,0.165 -0.283,0.462 -0.136,0.704l2.262,3.806c0.136,0.242 0.441,0.33 0.69,0.242l2.816,-1.111c0.588,0.44 1.198,0.814 1.911,1.089l0.418,2.915c0.046,0.264 0.283,0.462 0.566,0.462l4.523,0c0.283,0 0.52,-0.198 0.566,-0.462l0.418,-2.915c0.713,-0.286 1.323,-0.649 1.911,-1.089l2.816,1.111c0.249,0.088 0.554,0 0.69,-0.242l2.262,-3.806c0.135,-0.242 0.079,-0.539 -0.136,-0.704l-2.386,-1.826Z", style: { fillRule: 'nonzero' } }),
        React.createElement("g", null,
            React.createElement("path", { d: "M5.801,15.058c-0.151,-0 -0.266,-0.063 -0.347,-0.188c-0.08,-0.125 -0.088,-0.259 -0.024,-0.4l2.262,-5.254c0.081,-0.182 0.212,-0.274 0.395,-0.274c0.193,0 0.324,0.092 0.394,0.274l2.27,5.27c0.059,0.146 0.05,0.278 -0.028,0.396c-0.078,0.117 -0.194,0.176 -0.35,0.176c-0.081,-0 -0.157,-0.022 -0.23,-0.067c-0.072,-0.044 -0.124,-0.106 -0.156,-0.184l-1.997,-4.823l0.226,-0l-2.029,4.823c-0.038,0.084 -0.093,0.146 -0.165,0.188c-0.073,0.042 -0.146,0.063 -0.221,0.063Zm0.426,-1.347l0.322,-0.673l3.156,-0l0.322,0.673l-3.8,-0Z", style: { fill: textColor, fillRule: 'nonzero' } }),
            React.createElement("path", { d: "M12.128,15.058c-0.118,-0 -0.218,-0.039 -0.298,-0.118c-0.081,-0.078 -0.121,-0.175 -0.121,-0.289l0,-5.302c0,-0.12 0.04,-0.217 0.121,-0.293c0.08,-0.076 0.18,-0.114 0.298,-0.114l1.61,0c0.402,0 0.759,0.086 1.07,0.259c0.312,0.172 0.555,0.411 0.729,0.716c0.174,0.306 0.262,0.657 0.262,1.053c-0,0.381 -0.088,0.721 -0.262,1.018c-0.174,0.298 -0.417,0.53 -0.729,0.697c-0.311,0.167 -0.668,0.251 -1.07,0.251l-1.192,-0l0,1.715c0,0.114 -0.039,0.211 -0.116,0.289c-0.078,0.079 -0.179,0.118 -0.302,0.118Zm0.418,-2.874l1.192,0c0.247,0 0.464,-0.052 0.652,-0.157c0.188,-0.104 0.335,-0.248 0.443,-0.43c0.107,-0.183 0.161,-0.392 0.161,-0.627c-0,-0.25 -0.054,-0.471 -0.161,-0.661c-0.108,-0.191 -0.255,-0.341 -0.443,-0.451c-0.188,-0.109 -0.405,-0.164 -0.652,-0.164l-1.192,-0l0,2.49Z", style: { fill: textColor, fillRule: 'nonzero' } }),
            React.createElement("path", { d: "M17.143,15.058c-0.118,-0 -0.217,-0.039 -0.298,-0.118c-0.08,-0.078 -0.121,-0.175 -0.121,-0.289l0,-5.302c0,-0.12 0.041,-0.217 0.121,-0.293c0.081,-0.076 0.18,-0.114 0.298,-0.114c0.123,0 0.224,0.038 0.302,0.114c0.078,0.076 0.117,0.173 0.117,0.293l-0,5.302c-0,0.114 -0.039,0.211 -0.117,0.289c-0.078,0.079 -0.179,0.118 -0.302,0.118Z", style: { fill: textColor, fillRule: 'nonzero' } }))));
};

const commonCopy = () => {
    return {
        accredited_recipient_label: 'Accredited Data Recipient:',
        adatree_name: 'Adatree',
        button_label_back: 'Back',
        button_label_finished: 'Done',
        button_label_next: 'Next',
        button_label_no: 'No',
        button_label_yes: 'Yes',
        cdr_policy_label: 'CDR Policy',
        cdr_principal_label: 'Under CDR Principal:',
        fallback_data_holder_name: 'Your data provider',
        status_active_label: 'granted:',
        status_expired_label: 'expired:',
        status_requested_label: 'requested:',
        status_revoked_label: 'revoked:',
    };
};

const componentCopy = (adrDataRecipient, primaryDataRecipient, providerType) => {
    return {
        blocked_dataholder: {
            message: (name) => {
                return (React__default.createElement(React__default.Fragment, null,
                    "Unfortunately, we could not connect you to ",
                    React__default.createElement(Highlight, null, name),
                    "."));
            },
            reason: (name) => {
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Highlight, null, name),
                    " have not fully implemented the data sharing feature as part of the Consumer Data Right (CDR) specifications."));
            },
            action: (name) => {
                return (React__default.createElement(React__default.Fragment, null,
                    "Please contact ",
                    React__default.createElement(Highlight, null, name),
                    " to enquire about when they will be able to fully support sharing your data."));
            },
        },
        data_handling_info: {
            list_data_policy: (name, dataHandlingPolicy) => {
                return (React__default.createElement(React__default.Fragment, null,
                    "Speak to ",
                    name,
                    " for more information about how they will handle your data.",
                    ' ',
                    dataHandlingPolicy && (React__default.createElement(React__default.Fragment, null,
                        "You can view their data handling policy ",
                        React__default.createElement(LinkExternal, { href: dataHandlingPolicy, text: 'here' }))),
                    "."));
            },
            list_non_adr_disclaimer: (name) => {
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Highlight, null, name),
                    " only has access to the Insight not your ",
                    providerType,
                    " data used to generate the Insight. The Insight shared with ",
                    React__default.createElement(Highlight, null, name),
                    " is not subject to CDR protections."));
            },
            title: 'Who else has access to my data?',
        },
        data_holder: {
            not_listed: `My ${providerType} is not listed`,
        },
        general_information: {
            list_adr_context: `${primaryDataRecipient.name} use ${adrDataRecipient.name} to help you consent and access your data.`,
            list_cdr_acknowledgement: (dataHandlerName) => {
                return (React__default.createElement(React__default.Fragment, null,
                    dataHandlerName,
                    " is a CDR Representative of ",
                    adrDataRecipient.name));
            },
            list_cdr_protection: `Data shared with ${primaryDataRecipient.name} is not subject to CDR Protections.`,
            list_complaint: (React__default.createElement(React__default.Fragment, null,
                "If you would like to make a complaint, please email",
                ' ',
                React__default.createElement(LinkExternal, { href: `mailto:${primaryDataRecipient.complaintEmail}`, text: primaryDataRecipient.complaintEmail }),
                ".")),
            list_deleted: `When your consent expires or is revoked, all of the data you shared with ${adrDataRecipient.name} is automatically deleted within seconds.`,
            list_deleted_with_insights: `When your consent expires or is revoked, all of the data you shared with ${adrDataRecipient.name} which they are not legally required to keep is automatically deleted within seconds.`,
            list_manage_consent: 'You can manage your consent through the consent dashboard. A link will be provided to it in your consent receipt.',
            list_marketing: (dataRecipientName) => `${dataRecipientName} will never sell your data or use it for marketing.`,
            list_primary_more_info: (React__default.createElement(React__default.Fragment, null,
                "Find out more information on how ",
                primaryDataRecipient.name,
                " handle your data",
                ' ',
                React__default.createElement(LinkExternal, { href: primaryDataRecipient.cdrPolicyUrl, text: "here" }),
                ".")),
            list_records: (React__default.createElement(React__default.Fragment, null,
                "You can request copies of records relating to your consent and the data collected by emailing",
                ' ',
                React__default.createElement(LinkExternal, { href: `mailto:${primaryDataRecipient.dataSharingRevocationEmail}`, text: primaryDataRecipient.dataSharingRevocationEmail }),
                ".")),
            list_records_with_insights: (React__default.createElement(React__default.Fragment, null,
                "You can request copies of records relating to your consent, the data collected and any insights disclosed by emailing",
                ' ',
                React__default.createElement(LinkExternal, { href: `mailto:${primaryDataRecipient.dataSharingRevocationEmail}`, text: primaryDataRecipient.dataSharingRevocationEmail }),
                ".")),
            list_revoked: 'When you revoke consent, the services offered may cease to provide you with benefits.',
            list_security: (dataRecipientName) => `${dataRecipientName} will never ask for your ${providerType} login password. Your ${providerType} will send you a one-time password.`,
            list_sharing: (React__default.createElement(React__default.Fragment, null,
                "You can stop sharing data at any time by clicking the revoke button in the consent record. You can also email",
                ' ',
                React__default.createElement(LinkExternal, { href: `mailto:${primaryDataRecipient.dataSharingRevocationEmail}`, text: primaryDataRecipient.dataSharingRevocationEmail }),
                ".")),
            list_tasp_context: (taspDataRecipient) => `${taspDataRecipient.name} will facilitate the collection of your data on behalf of ${primaryDataRecipient.name}.`,
            list_third_party_more_info: (dataHandlerName, cdrPolicyUrl) => {
                return (React__default.createElement(React__default.Fragment, null,
                    "Find out more information on how ",
                    dataHandlerName,
                    " handles your data",
                    ' ',
                    React__default.createElement(LinkExternal, { href: cdrPolicyUrl, text: "here" }),
                    "."));
            },
            title: 'General information',
        },
        max_account_connected_message: {
            list_label: 'You currently have the following active consents:',
            list_item: (useCaeName, dataHolderName) => {
                return `${useCaeName} consent with ${dataHolderName}`;
            },
            sub_title: 'You have already connected all of your available accounts.',
            title: 'Sorry but you are unable to create a new consent.',
        },
        partner_message: {
            discreet_label: 'consent service provided by',
            what_label: (dataRecipients) => {
                const isBcdc = Helper.isBcdc(dataRecipients);
                return (React__default.createElement(React__default.Fragment, null,
                    isBcdc && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Highlight, null, primaryDataRecipient.name),
                        " is using ",
                        React__default.createElement(Highlight, null, adrDataRecipient.name),
                        " services to provide access to the consent data.")),
                    !isBcdc && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Highlight, null, primaryDataRecipient.name),
                        " is a CDR Representative of ",
                        React__default.createElement(Highlight, null, adrDataRecipient.name),
                        "."))));
            },
            why_label: (dataHolderName) => {
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Highlight, null, dataHolderName),
                    " will ask you to share your data with ",
                    React__default.createElement(Highlight, null, adrDataRecipient.name),
                    " for",
                    ' ',
                    React__default.createElement(Highlight, null, primaryDataRecipient.name),
                    "."));
            },
        },
    };
};

const consentCopy = (primaryDataRecipient, providerType) => {
    return {
        create: {
            consent_label: 'Consent',
            cancel_label: 'Cancel',
            save_label: 'Save',
            cancel_consent_message: 'Are you sure you want to cancel this consent?',
            cancel_edit_message: 'Are you sure you want to cancel editing this consent?',
            data_holder_input_label: `Choose your ${providerType}`,
            select_favourite_data_holder_title: `Select your ${providerType}`,
            select_more_data_holder_title: `More ${providerType}s`,
            title: (name) => {
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Highlight, null, primaryDataRecipient.name),
                    " requests access to your ",
                    React__default.createElement(Highlight, null, name),
                    " account data"));
            },
            data_handler_label: 'Your data will be shared with:',
        },
        details: {
            data_disclosure_label: 'Data disclosure',
            data_disclosure_message: 'You are sharing your data with the following:',
        },
        edit: {
            active_consent_message: 'Update your consent details',
            non_active_consent_message: (status) => {
                return `You are unable to edit your consent because the status is ${status}.`;
            },
            scope_additional_message: (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Highlight, null, primaryDataRecipient.name),
                " would like access to the following new data:")),
            scope_create_message: (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Highlight, null, primaryDataRecipient.name),
                " would like access to the following data:")),
            scope_for_insights_create_message: (insight) => {
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Highlight, null, primaryDataRecipient.name),
                    " would like access to the following data to ",
                    insight));
            },
            scope_read_only_message: (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Highlight, null, primaryDataRecipient.name),
                " has access to the following data:")),
            scope_remove_message: (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Highlight, null, primaryDataRecipient.name),
                " would like to remove access to the following data:")),
            up_to_date_message: 'Your consent details are up to date. There are no options for you to edit.',
        },
        scope: {
            tooltip_label: (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Highlight, null, primaryDataRecipient.name),
                " will receive access to the following data:")),
        },
    };
};

const errorCopy = () => {
    return {
        required: 'This field is required.',
    };
};

const generateCopy = (adrDataRecipient, primaryDataRecipient, industry) => {
    let providerType = 'data provider';
    if (industry === Industry.Banking) {
        providerType = 'bank';
    }
    else if (industry === Industry.Energy) {
        providerType = 'energy provider';
    }
    return {
        common: Object.assign({}, commonCopy()),
        consent: Object.assign({}, consentCopy(primaryDataRecipient, providerType)),
        component: Object.assign({}, componentCopy(adrDataRecipient, primaryDataRecipient, providerType)),
        error: Object.assign({}, errorCopy()),
    };
};
const CopyBuilder = {
    generateCopy,
};

const scalingFactor = 8;
const baseHtmlFontSize = 10;
const generatePaletteColor = (hexColour, contrastTextColour) => {
    const paletteColor = {
        light: lighten(hexColour, 0.1),
        main: hexColour,
        dark: darken(hexColour, 0.1),
    };
    if (contrastTextColour) {
        return Object.assign(Object.assign({}, paletteColor), { contrastText: contrastTextColour });
    }
    return paletteColor;
};
const CreateTheme = (appTheme, extendTheme) => {
    var _a, _b, _c, _d;
    const fontFamilyBase = appTheme.font.fontFamily;
    let fontFamilyHeadings = appTheme.font.fontFamily;
    if (appTheme.font.fontFamilyHeadings) {
        fontFamilyHeadings = appTheme.font.fontFamilyHeadings;
    }
    let buttonBorderRadius = '4px';
    if ((_b = (_a = appTheme.components) === null || _a === void 0 ? void 0 : _a.button) === null || _b === void 0 ? void 0 : _b.borderRadius) {
        buttonBorderRadius = (_d = (_c = appTheme.components) === null || _c === void 0 ? void 0 : _c.button) === null || _d === void 0 ? void 0 : _d.borderRadius;
    }
    const baseTheme = {
        palette: {
            mode: appTheme.mode === 'DARK' ? 'dark' : 'light',
            primary: generatePaletteColor(appTheme.colour.primary),
            secondary: generatePaletteColor(appTheme.colour.secondary),
            background_card: generatePaletteColor(appTheme.colour.backgrounds.card),
            background_hover: generatePaletteColor(appTheme.colour.backgrounds.hover),
            background_inputs: generatePaletteColor(appTheme.colour.backgrounds.inputs),
            background_modal: generatePaletteColor(appTheme.colour.backgrounds.modal),
            background_page: generatePaletteColor(appTheme.colour.backgrounds.page),
            button: generatePaletteColor(appTheme.colour.buttons.background, appTheme.colour.buttons.text),
            text_main: generatePaletteColor(appTheme.colour.text.main),
            text_link: generatePaletteColor(appTheme.colour.text.link),
            text_highlight: generatePaletteColor(appTheme.colour.text.highlight),
            background: {
                default: appTheme.colour.backgrounds.modal,
                paper: appTheme.colour.backgrounds.card,
            },
        },
        typography: {
            fontFamily: fontFamilyBase,
            // Set the HTML Base font size (px)
            // Useful to set the 10px simplification, remember to set "font-size:62.5%" on the html element
            // https://www.sitepoint.com/understanding-and-using-rem-units-in-css/
            htmlFontSize: baseHtmlFontSize,
            allVariants: {
                color: appTheme.colour.text.main,
            },
            h1: {
                fontFamily: fontFamilyHeadings,
                fontSize: '3rem',
                fontWeight: 300,
                letterSpacing: '0',
                lineHeight: '1.1',
            },
            h2: {
                fontFamily: fontFamilyHeadings,
                fontSize: '2.4rem',
                letterSpacing: '0.07px',
                lineHeight: '1.4',
            },
            h3: {
                fontFamily: fontFamilyHeadings,
                fontSize: '2.2rem',
                fontWeight: 300,
                letterSpacing: '0.07px',
                lineHeight: '1.6',
            },
            h4: {
                fontFamily: fontFamilyHeadings,
                fontSize: '2.0rem',
                fontWeight: 300,
                letterSpacing: '0.07px',
                lineHeight: '1.5',
            },
            h5: {
                fontFamily: fontFamilyHeadings,
                fontSize: '1.8rem',
                fontWeight: 300,
                letterSpacing: '0.07px',
                lineHeight: '1.5',
            },
            h6: {
                fontFamily: fontFamilyHeadings,
                fontSize: '1.7rem',
                fontWeight: 400,
                letterSpacing: '0.07px',
                lineHeight: '1.5',
            },
            body1: {
                fontSize: '1.6rem',
                letterSpacing: '0.1px',
                lineHeight: '1.4',
            },
            body2: {
                fontSize: '1.4rem',
                lineHeight: '1.5',
                letterSpacing: '0.3px',
            },
            subtitle1: {
                fontSize: '1.4rem',
                letterSpacing: '0.1px',
                lineHeight: '1.4',
                color: lighten(appTheme.colour.text.main, 0.3),
            },
            subtitle2: {
                fontSize: '1.2rem',
                letterSpacing: '0.1px',
                lineHeight: '1.4',
                color: lighten(appTheme.colour.text.main, 0.3),
            },
        },
        components: {
            MuiAutocomplete: {
                styleOverrides: {
                    option: {
                        '&.Mui-focused': { backgroundColor: appTheme.colour.backgrounds.hover + ' !important' },
                        '&[aria-selected="true"].Mui-focused': {
                            backgroundColor: appTheme.colour.backgrounds.hover + ' !important',
                        },
                    },
                    paper: {
                        backgroundColor: appTheme.colour.backgrounds.inputs,
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'capitalize',
                        borderRadius: buttonBorderRadius,
                    },
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        textTransform: 'capitalize',
                    },
                },
            },
        },
        // Set the spacing scaling factor (px)
        // Uses the baseHtmlFontSize, example
        // ( scalingFactor / baseHtmlFontSize) * factor = X rem
        // ( 8 / 10 ) * 1 = 0.8rem (8px since baseHtmlFontSize is 10)
        // ( 8 / 16 ) * 1 = 0.5rem (8px since baseHtmlFontSize is 16)
        spacing: (factor) => `${((scalingFactor / baseHtmlFontSize) * 10 * factor) / 10}rem`, // * 10 and / 10 to avoid JS IEEE 754 encoding error
    };
    let theme = baseTheme;
    if (extendTheme) {
        theme = Object.assign(Object.assign(Object.assign({}, baseTheme), extendTheme), { mixins: Object.assign(Object.assign({}, baseTheme.mixins), extendTheme.mixins), components: Object.assign(Object.assign({}, baseTheme.components), extendTheme.components), palette: Object.assign(Object.assign({}, baseTheme.palette), extendTheme.palette), transitions: Object.assign(Object.assign({}, baseTheme.transitions), extendTheme.transitions), typography: Object.assign(Object.assign({}, baseTheme.typography), extendTheme.typography), zIndex: Object.assign(Object.assign({}, baseTheme.zIndex), extendTheme.zIndex) });
    }
    return createTheme(theme);
};

const GlobalStyles = () => {
    return (React__default.createElement(Global, { styles: {
            '*': {
                padding: 0,
                margin: 0,
            },
            '*, *:before, *:after': {
                boxSizing: 'inherit',
            },
            html: {
                fontFamily: 'sans-serif',
                fontSize: '62.5%',
                boxSizing: 'border-box',
            },
            body: {
                fontSize: '1.6rem',
            },
            'ol, ul': {
                listStyle: 'none',
            },
            a: {
                textDecoration: 'none',
            },
            'a:active': {
                color: 'inherit',
            },
            '.adt-container': {
                containerType: 'inline-size',
            },
        } }));
};

const ThemeProvider = ({ theme, children, extendTheme }) => {
    return (React__default.createElement(ThemeProvider$1, { theme: CreateTheme(theme, extendTheme) },
        React__default.createElement(CssBaseline, null),
        React__default.createElement(GlobalStyles, null),
        children));
};

// MUI colour generator https://material.io/resources/color/
var ThemeMode;
(function (ThemeMode) {
    ThemeMode["LIGHT"] = "LIGHT";
    ThemeMode["DARK"] = "DARK";
})(ThemeMode || (ThemeMode = {}));
const defaultTheme = {
    mode: ThemeMode.LIGHT,
    colour: {
        primary: '#48dfd2',
        secondary: '#021c55',
        backgrounds: {
            card: '#ffffff',
            hover: '#c8f5f1',
            inputs: '#ffffff',
            modal: '#f5f5f5',
            page: '#ebebeb',
        },
        buttons: {
            background: '#48dfd2',
            text: '#212121',
        },
        text: {
            main: '#212121',
            link: '#1a0dab',
            highlight: '#1d50bf',
        },
    },
    font: {
        fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
    },
};
const darkTheme = {
    mode: ThemeMode.DARK,
    colour: {
        primary: '#48dfd2',
        secondary: '#021c55',
        backgrounds: {
            card: '#283461',
            hover: '#4a5271',
            inputs: '#283461',
            modal: '#1f294d',
            page: '#182039',
        },
        buttons: {
            background: '#48dfd2',
            text: '#000',
        },
        text: {
            main: '#f9f9f9',
            link: '#f6ca6e',
            highlight: '#48dfd2',
        },
    },
    font: {
        fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
    },
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

function randomEnum(anEnum) {
    // @ts-ignore ignore
    const enumValues = Object.keys(anEnum)
        .map((n) => Number.parseInt(n))
        .filter((n) => !Number.isNaN(n));
    const randomIndex = Math.floor(Math.random() * enumValues.length);
    const randomEnumValue = enumValues[randomIndex];
    return randomEnumValue;
}
const getTransactions = (numOfTransactions) => {
    const transactions = [];
    for (let index = 0; index < numOfTransactions; index++) {
        transactions.push(generateTransaction());
    }
    return transactions;
};
const generateTransaction = () => {
    return {
        accountId: v4(),
        transactionId: v4(),
        isDetailAvailable: false,
        type: randomEnum(BankingTransactionTypeEnum),
        status: randomEnum(BankingTransactionStatusEnum),
        description: 'OVERDRAWN FEE 01-JUNE-2022',
        postingDateTime: '2022-06-02T00:00:00+10:00',
        valueDateTime: undefined,
        executionDateTime: '2022-06-02T00:00:00+10:00',
        amount: (Math.floor(Math.random() * 199) - 99).toString(),
        currency: 'AUD',
        reference: '0014013',
        merchantName: undefined,
        merchantCategoryCode: undefined,
        billerCode: undefined,
        billerName: undefined,
        crn: undefined,
        apcaNumber: undefined,
        extendedData: {
            payer: 'Mr Adatree',
            payee: 'Red Bank Australia',
            extensionUType: randomEnum(BankingTransactionExtendedDataExtensionUTypeEnum),
            x2p101Payload: {
                extendedDescription: 'Adatree testing',
                endToEndId: 'Adatree testing',
                purposeCode: undefined,
            },
            service: randomEnum(BankingTransactionExtendedDataServiceEnum),
        },
        adatree: {
            consentId: 'abc8d9c3-6527-4349-a8fb-d1f7f90f225d',
            consumerId: 'idp|1234567890ABCDEF',
            cdrArrangementId: '8e228588-5821-4a6f-8b39-fb9c346e2158',
            dataHolderBrandId: '1234',
            useCaseId: 'HOME_LOAN',
            resourceId: v4(),
        },
    };
};
const bankTransactionsList = (numOfTransactions) => {
    return {
        data: {
            transactions: getTransactions(numOfTransactions),
        },
        links: { self: '' },
        meta: { totalRecords: numOfTransactions, totalPages: 1 },
    };
};
const bankData = {
    bankTransactionsList,
};

const redBank = () => {
    return {
        dataHolderBrandId: 'a3e0c26a-db81-491f-bfb2-90ea2da621c8',
        brandName: 'Red Australia Bank',
        logoUri: 'https://design.adatree.com.au/assets/images/rab_logo.png',
    };
};
const yellowBank = () => {
    return {
        dataHolderBrandId: '9a9cea5d-19c4-458b-ab79-c926455475d3',
        brandName: 'Yellow Bank of Australia',
        logoUri: 'https://design.adatree.com.au/assets/images/yba_logo.png',
    };
};
const blueBank = () => {
    return {
        dataHolderBrandId: '8a8cea5d-19c4-458b-ab79-c926455475d3',
        brandName: 'Royal Blue Bank of Australia',
        logoUri: 'https://design.adatree.com.au/assets/images/rbba-logo.png',
    };
};
const greenBank = () => {
    return {
        dataHolderBrandId: '7a7cea5d-19c4-458b-ab79-c926455475d3',
        brandName: 'Green Bank',
        logoUri: 'https://design.adatree.com.au/assets/images/gb-logo.png',
    };
};
const longBank = () => {
    return {
        dataHolderBrandId: '11111-11111',
        brandName: 'Long Bank of Australia',
        logoUri: 'https://placehold.co/800x200/000000/FFF?text=Long+Bank',
    };
};
const tallBank = () => {
    return {
        dataHolderBrandId: '22222-22222',
        brandName: 'Tall Bank of Australia',
        logoUri: 'https://placehold.co/200x800/000000/FFF?text=Tall+Bank',
    };
};
const ecoPowerEnergy = () => {
    return {
        dataHolderBrandId: 'e3e0c26a-db81-491f-bfb2-90ea2da621c8',
        brandName: 'Eco Power',
        logoUri: 'https://design.adatree.com.au/assets/images/eco-logo.png',
    };
};
const originalEnergy = () => {
    return {
        dataHolderBrandId: '9a9cea5d-19c4-458b-ab79-c926455475d3',
        brandName: 'Original Energy',
        logoUri: 'https://design.adatree.com.au/assets/images/org-logo.png',
    };
};
const ozGasEnergy = () => {
    return {
        dataHolderBrandId: '8a8cea5d-19c4-458b-ab79-c926455475d3',
        brandName: 'Oz Gas',
        logoUri: 'https://design.adatree.com.au/assets/images/ozg-logo.png',
    };
};
const yourPowerEnergy = () => {
    return {
        dataHolderBrandId: '7a7cea5d-19c4-458b-ab79-c926455475d3',
        brandName: 'Your Power',
        logoUri: 'https://design.adatree.com.au/assets/images/yp-logo.png',
    };
};
const allBanking = () => {
    return [redBank(), yellowBank(), blueBank(), greenBank()];
};
const allEngery = () => {
    return [ecoPowerEnergy(), originalEnergy(), ozGasEnergy(), yourPowerEnergy()];
};
const dataHolder = {
    allBanking,
    allEngery,
    redBank,
    yellowBank,
    longBank,
    tallBank,
    ecoPowerEnergy,
    originalEnergy,
    ozGasEnergy,
    yourPowerEnergy,
};

const adatree = () => {
    return {
        providerName: 'Adatree',
        accreditationId: '1234567890',
        serviceDescription: "They'll collect and analyse your data on our behalf. They delete your data as soon as they have provided this service on our behalf.",
        cdrPolicyUri: 'https://example.com',
    };
};
const outsourcedServiceProvider1 = () => {
    return {
        providerName: 'OSP 1',
        accreditationId: '1234567890',
        serviceDescription: "They'll collect and analyse your data on our behalf. They delete your data as soon as they have provided this service on our behalf.",
        cdrPolicyUri: 'https://example.com',
    };
};
const outsourcedServiceProvider2 = () => {
    return {
        providerName: 'OSP 2',
        accreditationId: '1234567890',
        serviceDescription: "They'll collect and analyse your data on our behalf. They delete your data as soon as they have provided this service on our behalf.",
        cdrPolicyUri: 'https://example.com',
    };
};
const all$6 = () => {
    return [adatree(), outsourcedServiceProvider1(), outsourcedServiceProvider2()];
};
const outsourcedServiceProvider = {
    all: all$6,
    adatree,
    outsourcedServiceProvider1,
    outsourcedServiceProvider2,
};

const bankAccountsBasicRead = () => {
    return {
        name: 'Account name, type and balance',
        id: 'bank:accounts.basic:read',
        purpose: 'We need your account name, type and balance for X reason.',
        description: 'This will allow us to access basic account information including the account balance.',
        claims: ['Name of account', 'Type of account', 'Account balance'],
        priority: 2,
    };
};
const bankAccountsDetailRead = () => {
    return {
        name: 'Account numbers and features',
        id: 'bank:accounts.detail:read',
        purpose: 'We need your account numbers and features for X reason.',
        description: 'This will allow us to access detailed bank account information including basic account information plus account identifiers and product information.',
        claims: ['Account number', 'Interest rates', 'Fees', 'Discounts', 'Account terms', 'Account mail address'],
        priority: 3,
    };
};
const bankTransactionsRead = () => {
    return {
        name: 'Transaction details',
        id: 'bank:transactions:read',
        purpose: 'We need your transaction details for X reason.',
        description: 'This will allow us to access bank account transaction data.',
        claims: [
            'Incoming and outgoing transactions',
            'Amounts',
            'Dates',
            'Descriptions of transactions',
            'Who you have sent money to and received money from (e.g. their name)',
        ],
        priority: 4,
    };
};
const commonCustomerBasicRead = () => {
    return {
        name: 'Name and occupation',
        id: 'common:customer.basic:read',
        purpose: 'We need your name and occupation for X reason.',
        description: 'This will allow us to access personally identifiable information about the customer. For retail customers this would be information about the customer. For businesses it would be the name of the specific user and information about the business.',
        claims: ['Name', 'Occupation'],
        priority: 0,
    };
};
const commonCustomerDetailRead = () => {
    return {
        name: 'Contact details',
        id: 'common:customer.detail:read',
        purpose: 'We need your personal details to X reason.',
        description: 'This will allow us to access more detailed customer information such as contact details.',
        claims: ['Phone', 'Email address', 'Mail address', 'Residential address'],
        priority: 1,
    };
};
const energyAccountsBasicRead = () => {
    return {
        name: 'Accounts and plans',
        id: 'energy:accounts.basic:read',
        purpose: 'We need your basic account information to X reason.',
        description: '',
        claims: ['Account and plan information', 'National Meter Identifier (NMI)'],
        priority: 7,
    };
};
const energyBillingRead = () => {
    return {
        name: 'Billing payments and history',
        id: 'energy:billing:read',
        purpose: 'We need your billing information to X reason.',
        description: '',
        claims: [
            'Account balance',
            'National Meter Identifier (NMI)',
            'Payment method',
            'Payment status',
            'Charges, discounts, credits',
            'Billing date',
            'Usage for billing period',
            'Payment date',
            'Invoice number',
        ],
        priority: 11,
    };
};
const energyElectricityUsageRead = () => {
    return {
        name: 'Electricity usage',
        id: 'energy:electricity.usage:read',
        purpose: 'We need your usage information to X reason.',
        description: '',
        claims: ['Usage', 'Meter details'],
        priority: 15,
    };
};
const energyAccountsDetailRead = () => {
    return {
        name: 'Account and plan details',
        id: 'energy:accounts.detail:read',
        purpose: 'We need your detailed account information to X reason.',
        description: '',
        claims: [
            'Account and plan information',
            'National Meter Identifier (NMI)',
            'Account type',
            'Fees, features, rates, and discounts',
            'Additional account users',
        ],
        priority: 8,
    };
};
const energyAccountsConcessionsRead = () => {
    return {
        name: 'Concessions and assistance',
        id: 'energy:accounts.concessions:read',
        purpose: 'We need your concession information to X reason.',
        description: '',
        claims: ['Concession type', 'Concession information'],
        priority: 9,
    };
};
const energyAccountsPaymentscheduleRead = () => {
    return {
        name: 'Stored payment information',
        id: 'energy:accounts.paymentschedule:read',
        purpose: 'We need your payments information to X reason.',
        description: '',
        claims: ['Payment details', 'Scheduled payment amount'],
        priority: 10,
    };
};
const energyElectricityServicepointsBasicRead = () => {
    return {
        name: 'Electricity connection',
        id: 'energy:electricity.servicepoints.basic:read',
        purpose: 'We need your basic service point information to X reason.',
        description: '',
        claims: ['National Meter Identifier (NMI)', 'Customer type', 'Connection point details'],
        priority: 12,
    };
};
const energyElectricityServicepointsDetailRead = () => {
    return {
        name: 'Electricity connection and meter',
        id: 'energy:electricity.servicepoints.detail:read',
        purpose: 'We need your detailed service point information to X reason.',
        description: '',
        claims: [
            'National Meter Identifier (NMI)',
            'Supply address',
            'Customer type',
            'Connection point details',
            'Meter details',
            'Associated service providers',
        ],
        priority: 13,
    };
};
const cdrInsightsOne = () => {
    return {
        name: 'Verify my Identity',
        id: 'cdr:insights:verify.identity',
        purpose: 'This is the CDR Insight purpose for Verify my Identity.',
        description: '',
        claims: ['Name', 'Residential address', 'Date of birth'],
        priority: 1,
    };
};
const cdrInsightsTwo = () => {
    return {
        name: 'CDR Insight 2',
        id: 'cdr:insights:example.two.basic:read',
        purpose: 'This is the CDR Insight purpose for CDR Insight 2.',
        description: '',
        claims: ['CDR claim 4', 'CDR claim 5', 'CDR claim 6'],
        priority: 2,
    };
};
const energyElectricityDerRead = () => {
    return {
        name: 'Energy generation and storage',
        id: 'energy:electricity.der:read',
        purpose: 'We need your energy generation information to X reason.',
        description: '',
        claims: [
            'Generation information',
            'Generation or storage device type',
            'Device characteristics',
            'Devices that can operate without the grid',
            'Energy conversion information',
        ],
        priority: 14,
    };
};
const all$5 = () => [
    bankAccountsBasicRead(),
    bankAccountsDetailRead(),
    bankTransactionsRead(),
    commonCustomerBasicRead(),
    commonCustomerDetailRead(),
    energyAccountsBasicRead(),
    energyBillingRead(),
    energyElectricityUsageRead(),
    energyAccountsDetailRead(),
    energyAccountsConcessionsRead(),
    energyAccountsPaymentscheduleRead(),
    energyElectricityServicepointsBasicRead(),
    energyElectricityServicepointsDetailRead(),
    energyElectricityDerRead(),
];
const scope = {
    all: all$5,
    bankAccountsBasicRead,
    bankAccountsDetailRead,
    bankTransactionsRead,
    cdrInsightsOne,
    cdrInsightsTwo,
    commonCustomerBasicRead,
    commonCustomerDetailRead,
    energyAccountsBasicRead,
    energyBillingRead,
    energyElectricityUsageRead,
    energyAccountsDetailRead,
    energyAccountsConcessionsRead,
    energyAccountsPaymentscheduleRead,
    energyElectricityServicepointsBasicRead,
    energyElectricityServicepointsDetailRead,
    energyElectricityDerRead,
};

const onceOffConsentMinScopes$1 = () => {
    return {
        id: 'ONCE_OFF_CONSENT_MIN_SCOPES',
        name: 'Once Off Consent - Minimal Scopes',
        active: true,
        softwareProductId: 'SPID-1234-5678',
        consumerType: ConsumerType.Any,
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to test a once off consent scenario for minimal scopes and APIs',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [
            scope.commonCustomerBasicRead(),
            scope.bankAccountsBasicRead(),
            scope.bankAccountsDetailRead(),
            scope.bankTransactionsRead(),
        ],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.OnceOff],
    };
};
const ongoingConsentMinScopes$1 = () => {
    return {
        id: 'ONGOING_CONSENT_MIN_SCOPES',
        name: 'Ongoing Consent - Minimal Scopes',
        active: true,
        softwareProductId: 'SPID-1234-5678',
        consumerType: ConsumerType.Any,
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to test an ongoing consent scenario for minimal scopes and APIs',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [
            scope.commonCustomerBasicRead(),
            scope.bankAccountsBasicRead(),
            scope.bankAccountsDetailRead(),
            scope.bankTransactionsRead(),
        ],
        accessFrequency: AccessFrequency.Ongoing,
        sharingDurations: [SharingDuration.Custom, SharingDuration.OneWeek, SharingDuration.ThreeMonths],
    };
};
const homeLoan$1 = () => {
    return {
        id: 'HOME_LOAN',
        name: 'Home Loan Application',
        active: true,
        softwareProductId: 'SPID-1234-5678',
        consumerType: ConsumerType.Any,
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to assess your suitability for a home loan',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [scope.bankAccountsBasicRead(), scope.bankTransactionsRead()],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.OnceOff],
    };
};
const consumerTypeOrg$1 = () => {
    return {
        id: 'CT_ORG',
        name: 'Consumer Type Organisation',
        active: true,
        softwareProductId: 'SPID-1234-5678',
        consumerType: ConsumerType.Organisation,
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to assess only for business disclosures.',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [scope.bankAccountsBasicRead(), scope.bankTransactionsRead()],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.SixMonths, SharingDuration.OneYear],
    };
};
const homeLoanWithOsps$1 = () => {
    return Object.assign(Object.assign({}, homeLoan$1()), { osps: outsourcedServiceProvider.all() });
};
const openEnergyLite$1 = () => {
    return {
        id: 'OPEN_ENERGY_LITE',
        name: 'Open Energy Lite',
        active: true,
        softwareProductId: 'SPID-1234-5678',
        consumerType: ConsumerType.Any,
        dataHolders: dataHolder.allEngery(),
        description: 'Your data will be used to assess the best energy provider for you',
        industries: [Industry.Energy],
        priority: 101,
        historicalCollectionPeriodInDays: 365,
        notificationType: NotificationType.Email,
        scopes: [
            scope.commonCustomerBasicRead(),
            scope.energyAccountsBasicRead(),
            scope.energyBillingRead(),
            scope.energyElectricityUsageRead(),
        ],
        accessFrequency: AccessFrequency.Ongoing,
        sharingDurations: [SharingDuration.Custom],
    };
};
const openEnergy$1 = () => {
    return {
        id: 'OPEN_ENERGY',
        name: 'Open Energy',
        active: true,
        softwareProductId: 'SPID-1234-5678',
        consumerType: ConsumerType.Any,
        dataHolders: dataHolder.allEngery(),
        description: 'Your data will be used to assess the best energy provider for you',
        industries: [Industry.Energy],
        priority: 100,
        historicalCollectionPeriodInDays: 365,
        notificationType: NotificationType.Email,
        scopes: [
            scope.commonCustomerBasicRead(),
            scope.commonCustomerDetailRead(),
            scope.energyAccountsBasicRead(),
            scope.energyAccountsDetailRead(),
            scope.energyAccountsConcessionsRead(),
            scope.energyAccountsPaymentscheduleRead(),
            scope.energyBillingRead(),
            scope.energyElectricityServicepointsBasicRead(),
            scope.energyElectricityServicepointsDetailRead(),
            scope.energyElectricityDerRead(),
            scope.energyElectricityUsageRead(),
        ],
        accessFrequency: AccessFrequency.Ongoing,
        sharingDurations: [SharingDuration.Custom],
    };
};
const deIdentification$1 = () => {
    return {
        id: 'DE_IDENTIFICATION',
        name: 'De-identification use case example',
        active: true,
        softwareProductId: 'SPID-1234-5678',
        consumerType: ConsumerType.Any,
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to assess your suitability and is de-identified on deletion',
        features: ['DE_IDENTIFICATION'],
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [scope.bankAccountsBasicRead(), scope.bankTransactionsRead()],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.OnceOff],
    };
};
const verifyIdentity = () => {
    return {
        features: ['CDRInsights'],
        id: 'INSIGHT_VERIFY_ID',
        name: 'Verify your identity',
        active: true,
        softwareProductId: 'SPID-1234-5678',
        consumerType: ConsumerType.Any,
        dataHolders: dataHolder.allBanking(),
        description: 'Access to your data is used to generate the insight Verify your identity.',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [scope.commonCustomerDetailRead(), scope.bankAccountsDetailRead()],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.OnceOff],
    };
};
const all$4 = () => [
    onceOffConsentMinScopes$1(),
    ongoingConsentMinScopes$1(),
    homeLoan$1(),
    consumerTypeOrg$1(),
    openEnergyLite$1(),
    openEnergy$1(),
    deIdentification$1(),
];
const useCase = {
    all: all$4,
    onceOffConsentMinScopes: onceOffConsentMinScopes$1,
    ongoingConsentMinScopes: ongoingConsentMinScopes$1,
    homeLoan: homeLoan$1,
    consumerTypeOrg: consumerTypeOrg$1,
    homeLoanWithOsps: homeLoanWithOsps$1,
    openEnergyLite: openEnergyLite$1,
    openEnergy: openEnergy$1,
    deIdentification: deIdentification$1,
    verifyIdentity,
};

const createConsent$1 = () => {
    let useCaseId = useCase.homeLoan().id;
    if (!useCaseId) {
        useCaseId = '';
    }
    return {
        consumerEmail: 'shane+test@adatree.com.au',
        sharingEndDate: new Date().toISOString(),
        dataHolderBrandId: '9a9cea5d-19c4-458b-ab79-c926455475d3',
        useCaseId: useCaseId,
        postUsageAction: PostUsageAction.DeIdentification,
        directMarketingAllowed: true,
    };
};
const active$1 = () => {
    return {
        consentId: 'abc8d9c3-6527-4349-a8fb-d1f7f90f225d',
        cdrArrangementId: '8e228588-5821-4a6f-8b39-fb9c346e2158',
        consumerId: '2',
        status: Status.Active,
        created: new Date(2020, 10, 25).toISOString(),
        consumerEmail: 'shane+test@adatree.com.au',
        sharingEndDate: new Date(2023, 10, 2).toISOString(),
        dataHolderName: dataHolder.yellowBank().brandName,
        dataHolderBrandId: dataHolder.yellowBank().dataHolderBrandId,
        dataHolderLogoUri: dataHolder.yellowBank().logoUri,
        useCase: useCase.homeLoan(),
        postUsageAction: PostUsageAction.Deletion,
        directMarketingAllowed: false,
    };
};
const activeWithConsumerTypeOrganisation$1 = () => {
    return Object.assign(Object.assign({}, active$1()), { consentId: 'fed8d9c3-6527-4349-a8fb-d1f7f90f225d', useCase: useCase.consumerTypeOrg() });
};
const activeWithGrantee$1 = () => {
    return Object.assign(Object.assign({}, active$1()), { grantee: { name: 'Nick the Broker', licenceNumber: '000999' } });
};
const activeWithDeIdentification$1 = () => {
    return Object.assign(Object.assign({}, active$1()), { postUsageAction: PostUsageAction.DeIdentification });
};
const revoked$1 = () => {
    return {
        consentId: 'f328b2fb-441e-951d-2f9e-2296af82cae1',
        cdrArrangementId: '6effe328-c468-4b58-b74e-7670aa64ce5b',
        consumerId: '2',
        status: Status.Revoked,
        created: new Date(2019, 10, 1).toISOString(),
        sharingEndDate: '2020-12-18T10:20:21.889Z',
        firstDataCollection: new Date(2019, 10, 2).toISOString(),
        consumerEmail: 'shane+test@adatree.com.au',
        revoked: new Date(2020, 11, 6).toISOString(),
        dataHolderName: dataHolder.redBank().brandName,
        dataHolderBrandId: dataHolder.redBank().dataHolderBrandId,
        dataHolderLogoUri: dataHolder.redBank().logoUri,
        useCase: useCase.ongoingConsentMinScopes(),
        postUsageAction: PostUsageAction.Deletion,
        directMarketingAllowed: false,
    };
};
const revokedWithGrantee$1 = () => {
    return Object.assign(Object.assign({}, revoked$1()), { grantee: { name: 'Nick the Broker', licenceNumber: '000999' } });
};
const requested$1 = () => {
    return {
        version: undefined,
        created: '2021-01-05T12:52:25.446231Z',
        firstDataCollection: undefined,
        revoked: undefined,
        lastNotificationSentAt: undefined,
        status: Status.Requested,
        sharingEndDate: '2021-01-05T12:52:09.804Z',
        consumerEmail: 'john+sample@adatree.com.au',
        dataHolderName: dataHolder.redBank().brandName,
        dataHolderBrandId: dataHolder.redBank().dataHolderBrandId,
        dataHolderLogoUri: dataHolder.redBank().logoUri,
        useCase: useCase.homeLoan(),
        postUsageAction: PostUsageAction.Deletion,
        consumerId: 'auth0|5f899e393c3f960069a81555',
        consentId: 'b89ce648-1589-470c-8829-9955379fc5fc',
        cdrArrangementId: 'a40de7e6-8439-4ad4-a8cc-9a84f6d0fb5e',
        directMarketingAllowed: false,
    };
};
const requestedWithGrantee$1 = () => {
    return Object.assign(Object.assign({}, requested$1()), { grantee: { name: 'Nick the Broker', licenceNumber: '000999' } });
};
const expired$1 = () => {
    return {
        version: undefined,
        created: '2020-12-18T10:20:40.123664Z',
        firstDataCollection: '2020-12-18T10:21:40.123664Z',
        revoked: undefined,
        lastNotificationSentAt: undefined,
        status: Status.Expired,
        sharingEndDate: '2020-12-18T10:20:21.889Z',
        consumerEmail: 'john+sample@adatree.com.au',
        dataHolderName: dataHolder.yellowBank().brandName,
        dataHolderBrandId: dataHolder.yellowBank().dataHolderBrandId,
        dataHolderLogoUri: dataHolder.yellowBank().logoUri,
        useCase: useCase.onceOffConsentMinScopes(),
        postUsageAction: PostUsageAction.DeIdentification,
        consumerId: 'auth0|5f899e393c3f960069a81555',
        consentId: '6e485649-3113-468d-8067-5f18580476f6',
        cdrArrangementId: 'd498ec89-a1e2-43c2-ab7c-38a6e5db5a24',
        directMarketingAllowed: false,
    };
};
const expiredWithGrantee$1 = () => {
    return Object.assign(Object.assign({}, expired$1()), { grantee: { name: 'Nick the Broker', licenceNumber: '000999' } });
};
const all$3 = () => {
    return [
        active$1(),
        activeWithConsumerTypeOrganisation$1(),
        activeWithDeIdentification$1(),
        activeWithGrantee$1(),
        revoked$1(),
        requested$1(),
        expired$1(),
        {
            consentId: '3ad2f7ce-18f4-451f-afb6-0077b339ddb4',
            cdrArrangementId: 'a2295dc3-fa81-456f-b1e4-8d57615109b4',
            consumerId: '2',
            status: Status.Active,
            created: new Date(2020, 10, 1).toISOString(),
            firstDataCollection: new Date(2020, 10, 2).toISOString(),
            consumerEmail: 'shane+test@adatree.com.au',
            dataHolderName: dataHolder.redBank().brandName,
            dataHolderBrandId: dataHolder.redBank().dataHolderBrandId,
            dataHolderLogoUri: dataHolder.redBank().logoUri,
            useCase: useCase.onceOffConsentMinScopes(),
            postUsageAction: PostUsageAction.Deletion,
            directMarketingAllowed: false,
        },
        {
            version: undefined,
            created: '2020-12-18T10:52:14.35377Z',
            firstDataCollection: '2020-12-18T10:55:14.35377Z',
            revoked: '2020-12-18T10:58:35.25313Z',
            lastNotificationSentAt: undefined,
            status: Status.Revoked,
            sharingEndDate: '2020-12-23T10:51:00Z',
            consumerEmail: 'john+sample@adatree.com.au',
            dataHolderName: dataHolder.redBank().brandName,
            dataHolderBrandId: dataHolder.redBank().dataHolderBrandId,
            dataHolderLogoUri: dataHolder.redBank().logoUri,
            useCase: useCase.openEnergy(),
            postUsageAction: PostUsageAction.DeIdentification,
            consumerId: 'auth0|5f899e393c3f960069a81555',
            consentId: '550b2d5a-2c52-4213-a9eb-3abe467d99a9',
            cdrArrangementId: 'c96b48d7-67ef-4752-8231-9816e9027681',
            directMarketingAllowed: false,
        },
    ];
};
const generateConsent$1 = (createConsent) => {
    return {
        consentId: getTestUuidV4$1(),
        cdrArrangementId: getTestUuidV4$1(),
        consumerId: '2',
        status: Status.Active,
        created: new Date().toISOString(),
        firstDataCollection: new Date().toISOString(),
        useCase: Object.assign(Object.assign({}, useCase.homeLoan()), { id: createConsent.useCaseId }),
        consumerEmail: createConsent.consumerEmail,
        sharingEndDate: createConsent.sharingEndDate,
        dataHolderBrandId: createConsent.dataHolderBrandId,
        dataHolderLogoUri: dataHolder.yellowBank().logoUri,
        postUsageAction: createConsent.postUsageAction,
        directMarketingAllowed: createConsent.directMarketingAllowed,
    };
};
const getTestUuidV4$1 = () => {
    const getRandomSymbol = (symbol) => {
        let array;
        if (symbol === 'y') {
            array = ['8', '9', 'a', 'b'];
            return array[Math.floor(Math.random() * array.length)];
        }
        array = new Uint8Array(1);
        window.crypto.getRandomValues(array);
        return (array[0] % 16).toString(16);
    };
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, getRandomSymbol);
};
const consent = {
    all: all$3,
    active: active$1,
    activeWithConsumerTypeOrganisation: activeWithConsumerTypeOrganisation$1,
    activeWithDeIdentification: activeWithDeIdentification$1,
    activeWithGrantee: activeWithGrantee$1,
    expiredWithGrantee: expiredWithGrantee$1,
    requestedWithGrantee: requestedWithGrantee$1,
    revokedWithGrantee: revokedWithGrantee$1,
    expired: expired$1,
    requested: requested$1,
    revoked: revoked$1,
    createConsent: createConsent$1,
    generateConsent: generateConsent$1,
};

const onceOffConsentMinScopes = () => {
    return {
        id: 'ONCE_OFF_CONSENT_MIN_SCOPES',
        name: 'Once Off Consent - Minimal Scopes',
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to test a once off consent scenario for minimal scopes and APIs',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [
            scope.commonCustomerBasicRead(),
            scope.bankAccountsBasicRead(),
            scope.bankAccountsDetailRead(),
            scope.bankTransactionsRead(),
        ],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.OnceOff],
        active: true,
        softwareProductId: 'SPID-001',
        consumerType: 'INDIVIDUAL',
    };
};
const ongoingConsentMinScopes = () => {
    return {
        id: 'ONGOING_CONSENT_MIN_SCOPES',
        name: 'Ongoing Consent - Minimal Scopes',
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to test an ongoing consent scenario for minimal scopes and APIs',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [
            scope.commonCustomerBasicRead(),
            scope.bankAccountsBasicRead(),
            scope.bankAccountsDetailRead(),
            scope.bankTransactionsRead(),
        ],
        accessFrequency: AccessFrequency.Ongoing,
        sharingDurations: [SharingDuration.Custom, SharingDuration.OneWeek, SharingDuration.ThreeMonths],
        active: true,
        softwareProductId: 'SPID-001',
        consumerType: 'INDIVIDUAL',
    };
};
const homeLoan = () => {
    return {
        id: 'HOME_LOAN',
        name: 'Home Loan Application',
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to assess your suitability for a home loan',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [scope.bankAccountsBasicRead(), scope.bankTransactionsRead()],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.OnceOff],
        active: true,
        softwareProductId: 'SPID-001',
        consumerType: 'INDIVIDUAL',
    };
};
const consumerTypeOrg = () => {
    return {
        id: 'CT_ORG',
        name: 'Consumer Type Organisation',
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to assess only for business disclosures.',
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        consumerType: ConsumerType.Organisation,
        scopes: [scope.bankAccountsBasicRead(), scope.bankTransactionsRead()],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.SixMonths, SharingDuration.OneYear],
        active: true,
        softwareProductId: 'SPID-001',
    };
};
const homeLoanWithOsps = () => {
    return Object.assign(Object.assign({}, homeLoan()), { osps: outsourcedServiceProvider.all() });
};
const openEnergyLite = () => {
    return {
        id: 'OPEN_ENERGY_LITE',
        name: 'Open Energy Lite',
        dataHolders: dataHolder.allEngery(),
        description: 'Your data will be used to assess the best energy provider for you',
        industries: [Industry.Energy],
        priority: 101,
        historicalCollectionPeriodInDays: 365,
        notificationType: NotificationType.Email,
        scopes: [
            scope.commonCustomerBasicRead(),
            scope.energyAccountsBasicRead(),
            scope.energyBillingRead(),
            scope.energyElectricityUsageRead(),
        ],
        accessFrequency: AccessFrequency.Ongoing,
        sharingDurations: [SharingDuration.Custom],
        active: true,
        softwareProductId: 'SPID-001',
        consumerType: 'INDIVIDUAL',
    };
};
const openEnergy = () => {
    return {
        id: 'OPEN_ENERGY',
        name: 'Open Energy',
        dataHolders: dataHolder.allEngery(),
        description: 'Your data will be used to assess the best energy provider for you',
        industries: [Industry.Energy],
        priority: 100,
        historicalCollectionPeriodInDays: 365,
        notificationType: NotificationType.Email,
        scopes: [
            scope.commonCustomerBasicRead(),
            scope.commonCustomerDetailRead(),
            scope.energyAccountsBasicRead(),
            scope.energyAccountsDetailRead(),
            scope.energyAccountsConcessionsRead(),
            scope.energyAccountsPaymentscheduleRead(),
            scope.energyBillingRead(),
            scope.energyElectricityServicepointsBasicRead(),
            scope.energyElectricityServicepointsDetailRead(),
            scope.energyElectricityDerRead(),
            scope.energyElectricityUsageRead(),
        ],
        accessFrequency: AccessFrequency.Ongoing,
        sharingDurations: [SharingDuration.Custom],
        active: true,
        softwareProductId: 'SPID-001',
        consumerType: 'INDIVIDUAL',
    };
};
const deIdentification = () => {
    return {
        id: 'DE_IDENTIFICATION',
        name: 'De-identification use case example',
        dataHolders: dataHolder.allBanking(),
        description: 'Data is used to assess your suitability and is de-identified on deletion',
        //@ts-ignore
        features: ['DE_IDENTIFICATION'],
        industries: [Industry.Banking],
        priority: 1,
        historicalCollectionPeriodInDays: 90,
        notificationType: NotificationType.Email,
        scopes: [scope.bankAccountsBasicRead(), scope.bankTransactionsRead()],
        accessFrequency: AccessFrequency.OnceOff,
        sharingDurations: [SharingDuration.OnceOff],
        active: true,
        softwareProductId: 'SPID-001',
        consumerType: 'INDIVIDUAL',
    };
};
const all$2 = () => [
    onceOffConsentMinScopes(),
    ongoingConsentMinScopes(),
    homeLoan(),
    consumerTypeOrg(),
    openEnergyLite(),
    openEnergy(),
    deIdentification(),
];
const useCaseV2 = {
    all: all$2,
    onceOffConsentMinScopes,
    ongoingConsentMinScopes,
    homeLoan,
    consumerTypeOrg,
    homeLoanWithOsps,
    openEnergyLite,
    openEnergy,
    deIdentification,
};

const createConsent = () => {
    let useCaseId = useCaseV2.homeLoan().id;
    if (!useCaseId) {
        useCaseId = '';
    }
    return {
        consumerEmail: 'shane+test@adatree.com.au',
        sharingEndDate: new Date().toISOString(),
        dataHolderBrandId: '9a9cea5d-19c4-458b-ab79-c926455475d3',
        useCaseId: useCaseId,
        postUsageAction: PostUsageAction.DeIdentification,
        directMarketingAllowed: true,
    };
};
const active = () => {
    return {
        consentId: 'abc8d9c3-6527-4349-a8fb-d1f7f90f225d',
        cdrArrangementId: '8e228588-5821-4a6f-8b39-fb9c346e2158',
        consumerId: '2',
        status: Status.Active,
        created: new Date(2020, 10, 25).toISOString(),
        consumerEmail: 'shane+test@adatree.com.au',
        sharingEndDate: new Date(2023, 10, 2).toISOString(),
        dataHolderName: dataHolder.yellowBank().brandName,
        dataHolderBrandId: dataHolder.yellowBank().dataHolderBrandId,
        dataHolderLogoUri: dataHolder.yellowBank().logoUri,
        useCase: useCaseV2.homeLoan(),
        postUsageAction: PostUsageAction.Deletion,
        directMarketingAllowed: false,
    };
};
const activeWithConsumerTypeOrganisation = () => {
    return Object.assign(Object.assign({}, active()), { consentId: 'fed8d9c3-6527-4349-a8fb-d1f7f90f225d', useCase: useCaseV2.consumerTypeOrg() });
};
const activeWithGrantee = () => {
    return Object.assign(Object.assign({}, active()), { grantee: { name: 'Nick the Broker', licenceNumber: '000999' } });
};
const activeWithDeIdentification = () => {
    return Object.assign(Object.assign({}, active()), { postUsageAction: PostUsageAction.DeIdentification });
};
const revoked = () => {
    return {
        consentId: 'f328b2fb-441e-951d-2f9e-2296af82cae1',
        cdrArrangementId: '6effe328-c468-4b58-b74e-7670aa64ce5b',
        consumerId: '2',
        status: Status.Revoked,
        created: new Date(2019, 10, 1).toISOString(),
        sharingEndDate: '2020-12-18T10:20:21.889Z',
        firstDataCollection: new Date(2019, 10, 2).toISOString(),
        consumerEmail: 'shane+test@adatree.com.au',
        revoked: new Date(2020, 11, 6).toISOString(),
        dataHolderName: dataHolder.redBank().brandName,
        dataHolderBrandId: dataHolder.redBank().dataHolderBrandId,
        dataHolderLogoUri: dataHolder.redBank().logoUri,
        useCase: useCaseV2.ongoingConsentMinScopes(),
        postUsageAction: PostUsageAction.Deletion,
        directMarketingAllowed: false,
    };
};
const revokedWithGrantee = () => {
    return Object.assign(Object.assign({}, revoked()), { grantee: { name: 'Nick the Broker', licenceNumber: '000999' } });
};
const requested = () => {
    return {
        version: undefined,
        created: '2021-01-05T12:52:25.446231Z',
        firstDataCollection: undefined,
        revoked: undefined,
        lastNotificationSentAt: undefined,
        status: Status.Requested,
        sharingEndDate: '2021-01-05T12:52:09.804Z',
        consumerEmail: 'john+sample@adatree.com.au',
        dataHolderName: dataHolder.redBank().brandName,
        dataHolderBrandId: dataHolder.redBank().dataHolderBrandId,
        dataHolderLogoUri: dataHolder.redBank().logoUri,
        useCase: useCaseV2.homeLoan(),
        postUsageAction: PostUsageAction.Deletion,
        consumerId: 'auth0|5f899e393c3f960069a81555',
        consentId: 'b89ce648-1589-470c-8829-9955379fc5fc',
        cdrArrangementId: 'a40de7e6-8439-4ad4-a8cc-9a84f6d0fb5e',
        directMarketingAllowed: false,
    };
};
const requestedWithGrantee = () => {
    return Object.assign(Object.assign({}, requested()), { grantee: { name: 'Nick the Broker', licenceNumber: '000999' } });
};
const expired = () => {
    return {
        version: undefined,
        created: '2020-12-18T10:20:40.123664Z',
        firstDataCollection: '2020-12-18T10:21:40.123664Z',
        revoked: undefined,
        lastNotificationSentAt: undefined,
        status: Status.Expired,
        sharingEndDate: '2020-12-18T10:20:21.889Z',
        consumerEmail: 'john+sample@adatree.com.au',
        dataHolderName: dataHolder.yellowBank().brandName,
        dataHolderBrandId: dataHolder.yellowBank().dataHolderBrandId,
        dataHolderLogoUri: dataHolder.yellowBank().logoUri,
        useCase: useCaseV2.onceOffConsentMinScopes(),
        postUsageAction: PostUsageAction.DeIdentification,
        consumerId: 'auth0|5f899e393c3f960069a81555',
        consentId: '6e485649-3113-468d-8067-5f18580476f6',
        cdrArrangementId: 'd498ec89-a1e2-43c2-ab7c-38a6e5db5a24',
        directMarketingAllowed: false,
    };
};
const expiredWithGrantee = () => {
    return Object.assign(Object.assign({}, expired()), { grantee: { name: 'Nick the Broker', licenceNumber: '000999' } });
};
const all$1 = () => {
    return [
        active(),
        activeWithConsumerTypeOrganisation(),
        activeWithDeIdentification(),
        activeWithGrantee(),
        revoked(),
        requested(),
        expired(),
        {
            consentId: '3ad2f7ce-18f4-451f-afb6-0077b339ddb4',
            cdrArrangementId: 'a2295dc3-fa81-456f-b1e4-8d57615109b4',
            consumerId: '2',
            status: Status.Active,
            created: new Date(2020, 10, 1).toISOString(),
            firstDataCollection: new Date(2020, 10, 2).toISOString(),
            consumerEmail: 'shane+test@adatree.com.au',
            dataHolderName: dataHolder.redBank().brandName,
            dataHolderBrandId: dataHolder.redBank().dataHolderBrandId,
            dataHolderLogoUri: dataHolder.redBank().logoUri,
            useCase: useCaseV2.onceOffConsentMinScopes(),
            postUsageAction: PostUsageAction.Deletion,
            directMarketingAllowed: false,
        },
        {
            version: undefined,
            created: '2020-12-18T10:52:14.35377Z',
            firstDataCollection: '2020-12-18T10:55:14.35377Z',
            revoked: '2020-12-18T10:58:35.25313Z',
            lastNotificationSentAt: undefined,
            status: Status.Revoked,
            sharingEndDate: '2020-12-23T10:51:00Z',
            consumerEmail: 'john+sample@adatree.com.au',
            dataHolderName: dataHolder.redBank().brandName,
            dataHolderBrandId: dataHolder.redBank().dataHolderBrandId,
            dataHolderLogoUri: dataHolder.redBank().logoUri,
            useCase: useCaseV2.openEnergy(),
            postUsageAction: PostUsageAction.DeIdentification,
            consumerId: 'auth0|5f899e393c3f960069a81555',
            consentId: '550b2d5a-2c52-4213-a9eb-3abe467d99a9',
            cdrArrangementId: 'c96b48d7-67ef-4752-8231-9816e9027681',
            directMarketingAllowed: false,
        },
    ];
};
const generateConsent = (createConsent) => {
    return {
        consentId: getTestUuidV4(),
        cdrArrangementId: getTestUuidV4(),
        consumerId: '2',
        status: Status.Active,
        created: new Date().toISOString(),
        firstDataCollection: new Date().toISOString(),
        useCase: Object.assign(Object.assign({}, useCaseV2.homeLoan()), { id: createConsent.useCaseId }),
        consumerEmail: createConsent.consumerEmail,
        sharingEndDate: createConsent.sharingEndDate,
        dataHolderBrandId: createConsent.dataHolderBrandId,
        dataHolderLogoUri: dataHolder.yellowBank().logoUri,
        postUsageAction: createConsent.postUsageAction,
        directMarketingAllowed: createConsent.directMarketingAllowed,
    };
};
const getTestUuidV4 = () => {
    const getRandomSymbol = (symbol) => {
        let array;
        if (symbol === 'y') {
            array = ['8', '9', 'a', 'b'];
            return array[Math.floor(Math.random() * array.length)];
        }
        array = new Uint8Array(1);
        window.crypto.getRandomValues(array);
        return (array[0] % 16).toString(16);
    };
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, getRandomSymbol);
};
const consentV2 = {
    all: all$1,
    active,
    activeWithConsumerTypeOrganisation,
    activeWithDeIdentification,
    activeWithGrantee,
    expiredWithGrantee,
    requestedWithGrantee,
    revokedWithGrantee,
    expired,
    requested,
    revoked,
    createConsent,
    generateConsent,
};

const accreditedDataRecipient = () => {
    return {
        complaintEmail: 'adr-complaint@example.com',
        cdrPolicyUrl: 'https://www.example.com/adr-cdr-policy',
        dataSharingRevocationEmail: 'adr.data.sharing.revocation@example.com',
        description: 'Accredited Data Recipient provides the service X.',
        logo: '/assets/images/adr-test-company-logo.png',
        name: 'Accredited Company',
        website: 'www.adr.example.com',
        type: DataRecipientType.ACCREDITED_DATA_RECIPIENT,
    };
};
const businessConsumerDisclosureConsent = () => {
    return {
        complaintEmail: 'bcdc-complaint@example.com',
        cdrPolicyUrl: 'https://www.example.com/bcdc-cdr-policy',
        dataSharingRevocationEmail: 'bcdc.data.sharing.revocation@example.com',
        description: 'BCDC representative provides the service X.',
        logo: '/assets/images/bcdc-test-company-logo.png',
        name: 'BCDC Representative Company',
        website: 'www.bcdc.example.com',
        type: DataRecipientType.BUSINESS_CONSUMER_DISCLOSURE_CONSENT,
    };
};
const cdrRepresentative = () => {
    return {
        complaintEmail: 'cdrr-complaint@example.com',
        cdrPolicyUrl: 'https://www.example.com/cdrr-cdr-policy',
        dataSharingRevocationEmail: 'cdrr.data.sharing.revocation@example.com',
        description: 'CDR representative provides the service X.',
        logo: '/assets/images/cdrr-test-company-logo.png',
        name: 'CDR Representative Company',
        website: 'www.cdr.example.com',
        type: DataRecipientType.CDR_REPRESENTATIVE,
    };
};
const granteeRepresentative = () => {
    return {
        complaintEmail: 'gr-complaint@example.com',
        cdrPolicyUrl: 'https://www.example.com/adr-cdr-policy',
        dataSharingRevocationEmail: 'gr.data.sharing.revocation@example.com',
        description: 'Grantee provides the service X.',
        logo: '/assets/images/adr-test-company-logo.png',
        name: 'Grantee Company',
        website: 'www.gr.example.com',
        type: DataRecipientType.GRANTEE,
    };
};
const nonAccreditedDataRecipient = () => {
    return {
        complaintEmail: 'non-adr-complaint@example.com',
        cdrPolicyUrl: 'https://www.example.com/non-adr-cdr-policy',
        dataSharingRevocationEmail: 'non-adr.data.sharing.revocation@example.com',
        description: 'Non Accredited Data Recipient provides the service X.',
        logo: '/assets/images/adr-test-company-logo.png',
        name: 'Non Accredited Company',
        website: 'www.na.example.com',
        type: DataRecipientType.NON_ACCREDITED_PERSON,
    };
};
const trustedAdvisor = () => {
    return {
        complaintEmail: 'ta-complaint@example.com',
        cdrPolicyUrl: 'https://www.example.com/ta-cdr-policy',
        dataSharingRevocationEmail: 'ta-data.sharing.revocation@example.com',
        description: 'Trusted Adviser provides the service X.',
        logo: '/assets/images/ta-test-company-logo.png',
        name: 'Trusted Advisor Company',
        website: 'www.ta.example.com',
        type: DataRecipientType.TRUSTED_ADVISER,
    };
};
const trustedAdvisorServiceProvider = () => {
    return {
        complaintEmail: 'tasp-complaint@example.com',
        cdrPolicyUrl: 'https://www.example.com/tasp-cdr-policy',
        dataSharingRevocationEmail: 'tasp-data.sharing.revocation@example.com',
        description: 'Trusted Adviser Service Provider provides the service X.',
        logo: '/assets/images/tasp-test-company-logo.png',
        name: 'Trusted Advisor Service Provider Company',
        website: 'www.tas.example.com',
        type: DataRecipientType.TRUSTED_ADVISER_SERVICE_PROVIDER,
    };
};
const all = () => {
    return [
        accreditedDataRecipient(),
        businessConsumerDisclosureConsent(),
        cdrRepresentative(),
        granteeRepresentative(),
        trustedAdvisor(),
        trustedAdvisorServiceProvider(),
    ];
};
const dataRecipient = {
    all,
    accreditedDataRecipient,
    businessConsumerDisclosureConsent,
    cdrRepresentative,
    granteeRepresentative,
    nonAccreditedDataRecipient,
    trustedAdvisor,
    trustedAdvisorServiceProvider,
};

const suspendLogger = () => {
    Logger.debug = jest.fn();
    Logger.info = jest.fn();
    Logger.warn = jest.fn();
    Logger.error = jest.fn();
};
const TestUtil = {
    testData: {
        bankData,
        consent,
        consentV2,
        dataHolder,
        dataRecipient,
        outsourcedServiceProvider,
        scope,
        useCase,
        useCaseV2,
    },
    suspendLogger,
};

const HighResDataHoldersLogos = [
    {
        brandName: 'ANZ',
        dataHolderBrandId: 'f4562bb8-e394-ea11-a831-000d3a8842e1',
        logoUri: 'https://design.adatree.com.au/assets/images/data-holders/banks/anz-logo.svg',
    },
    {
        brandName: 'CommBank',
        dataHolderBrandId: '25233bad-e494-ea11-a831-000d3a8842e1',
        logoUri: 'https://design.adatree.com.au/assets/images/data-holders/banks/commbank-logo.svg',
    },
    {
        brandName: 'NAB',
        dataHolderBrandId: '25797662-e294-ea11-a831-000d3a8842e1',
        logoUri: 'https://design.adatree.com.au/assets/images/data-holders/banks/nab-logo.svg',
    },
    {
        brandName: 'Westpac',
        dataHolderBrandId: 'ffe2945b-e094-ea11-a831-000d3a8842e1',
        logoUri: 'https://design.adatree.com.au/assets/images/data-holders/banks/westpac-logo.svg',
    },
];
const getHighResLogoUri = (dataholder) => {
    let logoUri = dataholder.logoUri;
    for (let i = 0; i < HighResDataHoldersLogos.length; i++) {
        if (HighResDataHoldersLogos[i].dataHolderBrandId === dataholder.dataHolderBrandId) {
            logoUri = HighResDataHoldersLogos[i].logoUri;
            break;
        }
    }
    return logoUri;
};
const Images = {
    getHighResLogoUri,
};

export { Accordion, Accreditation, AlertInputFrom, AnalyticsAction, AnalyticsComponentMeta, AnalyticsEvents, AnalyticsProvider, ApiCogIcon, AutocompleteDropdown, BlockedDataholderDialog, Card, CheckboxAccordion, Confirmation, ConsentCancelButton, ConsentCreate, ConsentCreateForm, ConsentDetails, ConsentEdit, ConsentFormProvider, ConsentList, ConsentListItem, ConsentSectionDeIdentify, ConsentTabs, CopyBuilder, CopyProvider, CreateTheme, DataDisclosure, DataHandlingInfo, DataHolderHeader, DataHolderTiles, DataRecipientType, DataRecipientsProvider, DateButton, DatePicker, DateSelector, DateSummary, Debugger, ErrorMessage, FeedbackMessage, Formatter, GeneralInformation, Helper, Highlight, IconListItem, IconWithText, Images, InsightConfirmationForm, InsightList, LinkExternal, Logger, MaxAccountConnectedMessage, NewFeature, PartnerMessage, RadioButtonWithText, RevokeDialog, ScopeList, ScopeListCheckbox, ScopeListSwitch, SectionCard, SupportingParties, SwitchDialog, TestUtil, ThemeMode, ThemeProvider, Tooltip, UseCaseSelector, UseCaseSummary, darkTheme, defaultTheme, useAnalytics, useConsentForm, useCopy, useDataRecipients };
